import React, {useEffect, useState} from "react";
import EnterpriseObject from "../eoec/eo/EnterpriseObject";
import enterpriseObjectClassFactory from "../eoec/EnterpriseObjectClassFactory";
import {Avatar, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Link, ListItemIcon, ListItemText, Menu, MenuItem, Popover, TextField, Tooltip, Typography} from "@mui/material";
import { useLocation } from 'react-router'
import EnterpriseComponent from "../eoec/ec/EnterpriseComponent";
import {prepareBuffer} from "../util/Buffer";
import {Blue3, Green4, Grey3, Grey5, Grey6, Black, Grey4, Grey17, Grey7} from "../theme/styles";
import css_buttons from "../../src/components/Common/css/CCButton.module.scss";
import css_pages from "./css/Pages.module.scss";
import moment from "moment-timezone";

import {
    Add,
    AddCircle,
    Circle,
    CloudDone,
    ContentCopy,
    ControlPoint,
    Delete,
    Edit,
    Info,
    KeyboardArrowDown,
    KeyboardArrowUp,
    KeyboardBackspace,
    MoreVert,
    North,
    South,
    FilterList,
    SwapVerticalCircle,
    VerticalAlignBottom,
    VerticalAlignTop,
    FilterAltOutlined,
    Check, CircleOutlined, DescriptionOutlined
} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";
import {formatLocalDate} from "../util/Formatters";
import {hasPrivilege, SessionContext, useSessionContext} from "../util/SessionContext";
import {makeEnterpriseComponent, updateObject} from "../util/utility";
import PrimaryPositionFormApplet from "../eoec/applet/impl/ProjectPlan/PrimaryPositionFormApplet";
import PrimaryUserGroupFormApplet from "../eoec/applet/impl/ProjectPlan/PrimaryUserGroupFormApplet";
import PrimaryWorkGroupFormApplet from "../eoec/applet/impl/ProjectPlan/PrimaryWorkGroupFormApplet";
import EventBus from "../util/EventBus";
import SecondaryPositionFormApplet from "../eoec/applet/impl/ProjectPlan/SecondaryPositionFormApplet";
import SecondaryUserGroupFormApplet from "../eoec/applet/impl/ProjectPlan/SecondaryUserGroupFormApplet";
import spinner from "../assets/Spinner-1s-200px.svg";
import ProjectPlanPhaseFormApplet from "../eoec/applet/impl/ProjectPlan/ProjectPlanPhaseFormApplet";
import MemoryContext from "../util/MemoryContext";
import ProjectPlanPhaseMilestoneFormApplet from "../eoec/applet/impl/ProjectPlan/ProjectPlanPhaseMilestoneFormApplet";
import ProjectPlanPhaseMilestoneDetail from "../components/ProjectPlan/ProjectPlanPhaseMilestoneDetail";
import ProjectPlanPhaseDetail from "../components/ProjectPlan/ProjectPlanPhaseDetail";
import PermissionConfiguration from "../components/Administration/PermissionConfiguration";
import ProjectPlanFormApplet from "../eoec/applet/impl/ProjectPlan/ProjectPlanFormApplet";
import ProjectPlanPhaseMilestoneDelete from "../components/ProjectPlan/ProjectPlanPhaseMilestoneDelete";
import ProjectPlanPhaseDelete from "../components/ProjectPlan/ProjectPlanPhaseDelete";
import ProjectPlanAuditLogTableApplet from "../eoec/applet/impl/ProjectPlan/ProjectPlanAuditLogTableApplet";
import css_enlil_table from "../components/Common/css/EnlilTable.module.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDiamond} from "@fortawesome/free-solid-svg-icons";
import { faDiamond as faDiamondRegular } from '@fortawesome/pro-regular-svg-icons'
import ProjectPlanDelete from "../components/ProjectPlan/ProjectPlanDelete";
import {v4 as uuidv4} from "uuid";
import ProjectPlanMilestoneRelocate from "../components/ProjectPlan/ProjectPlanMilestoneRelocate";
import CopyMilestone from "../components/ProjectPlan/CopyMilestone";
import CopyPhase from "../components/ProjectPlan/CopyPhase";
import CopyPlan from "../components/ProjectPlan/CopyPlan";
import CCButton from "../components/Common/CCButton";

type PhaseExpansion = {
    ProjectPhaseUSID: string,
    Expanded: boolean
}

type ActiveFilter = {
    Title: string,
    Subtitle: string
}

export default function ProjectPlanDetail() {
    const [projectPlanEnterpriseObject] = useState(enterpriseObjectClassFactory("ProjectPlan") as EnterpriseObject);
    const [adminPositionEnterpriseComponent] = useState(makeEnterpriseComponent("AdminPosition"));
    const [adminUserGroupEnterpriseComponent] = useState(makeEnterpriseComponent("AdminUserGroup"));
    const [adminPositionMembershipEnterpriseComponent] = useState(makeEnterpriseComponent("AdminPositionMembership"));
    const [adminUserGroupMembershipEnterpriseComponent] = useState(makeEnterpriseComponent("AdminUserGroupMembership"));
    const [adminWorkGroupMembershipEnterpriseComponent] = useState(makeEnterpriseComponent("AdminWorkGroupMembership"));

    // @ts-ignore
    MemoryContext.components["ProjectPlanDetail-EO"] = projectPlanEnterpriseObject;

    const navigate = useNavigate();
    const sessionContext: SessionContext = useSessionContext();

    // @ts-ignore
    let location = useLocation()
    let inboundProjectPlanUSID: string | undefined = undefined;
    let inboundProjectPlanPhaseUSID: string | undefined = undefined;

    if (sessionContext.getURL() !== null && sessionContext.getURL()!.includes("projectPlanUSID") && sessionContext.getURL()!.includes("projectPlanPhaseUSID")) {
        if ((sessionContext.getURL()!.match(new RegExp("=", "g")) || []).length === 1) {
            inboundProjectPlanUSID = sessionContext.getURL()!.substring(sessionContext.getURL()!.indexOf("=") + 1, sessionContext.getURL()!.length);
        } else if ((sessionContext.getURL()!.match(new RegExp("=", "g")) || []).length > 1) {
            let params: string[] = sessionContext.getURL()!.substring(sessionContext.getURL()!.indexOf("?") + 1, sessionContext.getURL()!.length).split("?")
            if (params.length === 2) {
                for (let param of params) {
                    let param_value = param.split("=");
                    if (param_value[0] === "projectPlanUSID") {
                        inboundProjectPlanUSID = param_value[1];
                    }
                    if (param_value[0] === "projectPlanPhaseUSID") {
                        inboundProjectPlanPhaseUSID = param_value[1];
                    }
                }
            }
        }
    } else {
        inboundProjectPlanUSID = location.state.projectPlanUSID;
    }

    if (inboundProjectPlanUSID === undefined) {
        window.location.href = "/"
    }

    // const [menu, setMenu] = React.useState<MenuSelection | null>(null);
    const [currentAssigneeFilterUSID, setCurrentAssigneeFilterUSID] = useState<string>();
    const [projectPlanUSID, setProjectPlanUSID] = React.useState<string | null>(null);
    const [pane, setPane] = React.useState<string | null>("PLANNING");
    const [showFilterMenu, setShowFilterMenu] = React.useState<EventTarget & HTMLButtonElement | null>(null);
    const [showMyMilestones, setShowMyMilestones] = React.useState<boolean>(false);
    const [showMilestonesByAssignee, setShowMilestonesByAssignee] = React.useState<boolean>(false);
    const [showMilestonesByAssigneeDialog, setShowMilestonesByAssigneeDialog] = React.useState<boolean>(false);
    const [showMilestonesByAssigneeUSID, setShowMilestonesByAssigneeUSID] = React.useState<string | null>(null);
    const [showEditPrimaryPosition, setShowEditPrimaryPosition] = React.useState<boolean>(false);
    const [showEditPrimaryUserGroup, setShowEditPrimaryUserGroup] = React.useState<boolean>(false);
    const [showEditPrimaryWorkGroup, setShowEditPrimaryWorkGroup] = React.useState<boolean>(false);
    const [showAddSecondaryPosition, setShowAddSecondaryPosition] = React.useState<boolean>(false);
    const [showAddSecondaryUserGroup, setShowAddSecondaryUserGroup] = React.useState<boolean>(false);
    const [showAddSecondaryWorkGroup, setShowAddPrimaryWorkGroup] = React.useState<boolean>(false);
    const [showProjectPlanDisplayOptionsMenu, setShowProjectPlanDisplayOptionsMenu] = React.useState<boolean>(false);
    const [showProjectPlanDisplayOptionsAnchor, setShowProjectPlanDisplayOptionsAnchor] = React.useState<EventTarget & HTMLButtonElement | null>(null);
    const [projectPlanFetchBackgroundOperation, setProjectPlanFetchBackgroundOperation] = React.useState<boolean>(false);
    const [positionMembershipFetchBackgroundOperation, setPositionMembershipFetchBackgroundOperation] = React.useState<boolean>(false);
    const [userGroupMembershipFetchBackgroundOperation, setUserGroupMembershipFetchBackgroundOperation] = React.useState<boolean>(false);
    const [adminPositionMembershipDeleteUSID, setAdminPositionMembershipDeleteUSID] = React.useState<string | null>(null);
    const [adminUserGroupMembershipDeleteUSID, setAdminUserGroupMembershipDeleteUSID] = React.useState<string | null>(null);
    const [timePerspective, setTimePerspective] = React.useState<string | null>("Year");
    const [referenceTimestamp, setReferenceTimestamp] = React.useState<any>(moment())
    const [projectPlanBuffer, setProjectPlanBuffer] = React.useState<Map<string, any>>(new Map<string, any>());
    const [adminPositionMembershipBuffer, setAdminPositionMembershipBuffer] = React.useState<Map<string, any>[]>([]);
    const [adminPositionBuffer, setAdminPositionBuffer] = React.useState<Map<string, any>[]>([]);
    const [adminUserGroupBuffer, setAdminUserGroupBuffer] = React.useState<Map<string, any>[]>([]);
    const [adminUserGroupMembershipBuffer, setAdminUserGroupMembershipBuffer] = React.useState<Map<string, any>[]>([]);
    const [adminWorkGroupMembershipBuffer, setAdminWorkGroupMembershipBuffer] = React.useState<Map<string, any>[]>([]);
    const [phaseExpansion, setPhaseExpansion] = React.useState<Map<string, PhaseExpansion>>(new Map<string, PhaseExpansion>());
    const [showAddPhase, setShowAddPhase] = React.useState(false);
    const [showAddPhaseMilestone, setShowAddPhaseMilestone] = React.useState(false);
    const [showPanelForMilestone, setShowPanelForMilestone] = React.useState(null);
    const [showDeletePhaseMilestone, setShowDeletePhaseMilestone] = React.useState(null);
    const [showDeletePlan, setShowDeletePlan] = React.useState(false);
    const [showMilestoneRelocate, setShowMilestoneRelocate] = React.useState<string | null>(null);
    const [showPanelForPhase, setShowPanelForPhase] = React.useState(null);
    const [showEditPlan, setShowEditPlan] = React.useState(false);
    const [showAlphabetFilter, setShowAlphabetFilter] = React.useState(false);
    const [quickFilterMenu, setQuickFilterMenu] = React.useState<EventTarget & HTMLButtonElement | null>(null);
    const [quickFilter, setQuickFilter] = React.useState<string | null>(null);
    const [showDeletePhase, setShowDeletePhase] = React.useState(null);
    const [showPhaseOptionMenu, setShowPhaseOptionMenu] = React.useState<string | null>(null);
    const [phaseOptionMenuAnchor, setPhaseOptionMenuAnchor] = React.useState<EventTarget & HTMLButtonElement | null>(null);
    const [showMilestoneOptionMenu, setShowMilestoneOptionMenu] = React.useState<string | null>(null);
    const [milestoneOptionMenuAnchor, setMilestoneOptionMenuAnchor] = React.useState<EventTarget & HTMLButtonElement | null>(null);
    const [quickFilterMenuOption, setQuickFilterMenuOption] = React.useState<string|null>("Contains");
    const [controls, setControls] = useState<any>({"QuickFilter": {"value": ""}});
    const [showCopyMilestone, setShowCopyMilestone] = useState(null);
    const [showCopyPhase, setShowCopyPhase] = useState(null);
    const [showCopyPlan, setShowCopyPlan] = useState<boolean>(false);
    const [activeFilter, setActiveFilter] = useState<ActiveFilter | null>(null);

    function enterpriseComponentLoadStartedListener(ec: EnterpriseComponent) {
        if (ec.getName() === "ProjectPlan") {
            setProjectPlanFetchBackgroundOperation(true)
        }
        if (ec.getName() === "PositionMembership") {
            setPositionMembershipFetchBackgroundOperation(true)
        }
        if (ec.getName() === "UserGroupMembership") {
            setUserGroupMembershipFetchBackgroundOperation(true)
        }
        if (ec.getName() === "WorkGroupMembership") {
            // setPositionMembershipFetchBackgroundOperation(true)
        }
    }

    function enterpriseComponentInsertCompletedListener(ec: EnterpriseComponent) {
        let b: Map<string, any>[] = prepareBuffer(ec)
        if (ec.getName() === "ProjectPlan") {
            setProjectPlanBuffer(b[0]);
        }
        if (ec.getName() === "AdminPositionMembership") {
            setAdminPositionMembershipBuffer(b);
            setPositionMembershipFetchBackgroundOperation(false)
        }
        if (ec.getName() === "AdminUserGroupMembership") {
            setAdminUserGroupMembershipBuffer(b);
            setUserGroupMembershipFetchBackgroundOperation(false)
        }
        if (ec.getName() === "AdminWorkGroupMembership") {
            setAdminWorkGroupMembershipBuffer(b);
            // setPositionMembershipFetchBackgroundOperation(false)
        }
        if (ec.getName() === "ProjectPlanPhase" || ec.getName() === "ProjectPlanPhaseMilestone") {
            let projectPlanEnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!;
            projectPlanEnterpriseComponent.newQuery();
            projectPlanEnterpriseComponent.setAttributeValue("USID", inboundProjectPlanUSID);
            if (quickFilter !== null) {
                projectPlanEnterpriseComponent.setAttributeValue("Name", quickFilter);
            }

            projectPlanEnterpriseComponent.setIDOCRequest("v1.ProjectPlan-002");
            projectPlanEnterpriseComponent.setIDOCResponse("v1.ProjectPlan-002");
            projectPlanEnterpriseComponent.executeQuery(1, 5);
        }
    }

    function enterpriseComponentLoadCompletedListener(ec: EnterpriseComponent) {
        let b: Map<string, any>[] = prepareBuffer(ec)
        if (ec.getName() === "ProjectPlan") {
            setProjectPlanBuffer(b[0]);
            adminPositionEnterpriseComponent.newQuery();
            adminPositionEnterpriseComponent.setAttributeValue("USID", b[0].get("PrimaryPositionUSID"));
            adminPositionEnterpriseComponent.setIDOCResponse("v1.AdminPosition-002")
            adminPositionEnterpriseComponent.executeQuery(1, 1);

            adminUserGroupEnterpriseComponent.newQuery();
            adminUserGroupEnterpriseComponent.setAttributeValue("USID", b[0].get("PrimaryUserGroupUSID"));
            adminUserGroupEnterpriseComponent.setIDOCResponse("v1.AdminUserGroup-002")
            adminUserGroupEnterpriseComponent.executeQuery(1, 1);
            setProjectPlanFetchBackgroundOperation(false)

            if (inboundProjectPlanPhaseUSID) {
                // @ts-ignore
                setShowPanelForPhase({"USID": inboundProjectPlanPhaseUSID!});
                inboundProjectPlanPhaseUSID = undefined;
            }
        }
        if (ec.getName() === "AdminPositionMembership") {
            setAdminPositionMembershipBuffer(b);
            setPositionMembershipFetchBackgroundOperation(false)
        }
        if (ec.getName() === "AdminUserGroupMembership") {
            setAdminUserGroupMembershipBuffer(b);
            setUserGroupMembershipFetchBackgroundOperation(false)
        }
        if (ec.getName() === "AdminWorkGroupMembership") {
            setAdminWorkGroupMembershipBuffer(b);
            // setPositionMembershipFetchBackgroundOperation(false)
        }
        if (ec.getName() === "AdminPosition") {
            setAdminPositionBuffer(b);
            // setAdminPositionFetchBackgroundOperation(false)
        }
        if (ec.getName() === "AdminUserGroup") {
            setAdminUserGroupBuffer(b);
            // setAdminPositionFetchBackgroundOperation(false)
        }

    }

    function enterpriseComponentUpdateCompletedListener(ec: EnterpriseComponent) {
        let b: Map<string, any>[] = prepareBuffer(ec)
        if (ec.getName() === "ProjectPlan") {
            setProjectPlanBuffer(b[0]);
            adminPositionEnterpriseComponent.newQuery();
            adminPositionEnterpriseComponent.setSearchSpecification({"USID": b[0].get("PrimaryPositionUSID")});
            adminPositionEnterpriseComponent.setIDOCResponse("v1.AdminPosition-002")
            adminPositionEnterpriseComponent.executeQuery(1, 1);

            adminUserGroupEnterpriseComponent.newQuery();
            adminUserGroupEnterpriseComponent.setSearchSpecification({"USID": b[0].get("PrimaryUserGroupUSID")});
            adminUserGroupEnterpriseComponent.setIDOCResponse("v1.AdminUserGroup-002")
            adminUserGroupEnterpriseComponent.executeQuery(1, 1);
        }
        if (ec.getName() === "ProjectPlanPhase") {
            const projectPlanEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!
            projectPlanEnterpriseComponent.invalidate();
        }
        if (ec.getName() === "ProjectPlanPhaseMilestone") {
            const projectPlanEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!
            projectPlanEnterpriseComponent.invalidate();
        }
    }

    function enterpriseComponentDeleteCompletedListener(ec: EnterpriseComponent) {
        let b: Map<string, any>[] = prepareBuffer(ec)
        if (ec.getName() === "AdminPositionMembership") {
            setAdminPositionMembershipDeleteUSID(null);
            setAdminPositionMembershipBuffer(b);
        }
        if (ec.getName() === "AdminUserGroupMembership") {
            setAdminUserGroupMembershipDeleteUSID(null);
            setAdminUserGroupMembershipBuffer(b);
        }
    }

    function enterpriseComponentInvalidateCompletedListener(ec: EnterpriseComponent) {
        ec.newQuery();
        ec.setAttributeValue("USID", inboundProjectPlanUSID);
        ec.setIDOCRequest("v1.ProjectPlan-002");
        ec.setIDOCResponse("v1.ProjectPlan-002");
        ec.executeQuery(1, 5);
    }

    function handlePhaseMoveToTop(projectPhaseUSID: string) {
        setProjectPlanFetchBackgroundOperation(true)
        const projectPlanPhaseEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanPhase")!
        projectPlanPhaseEnterpriseComponent.newEdit();
        projectPlanPhaseEnterpriseComponent.setAttributeValue("USID", projectPhaseUSID);
        projectPlanPhaseEnterpriseComponent.setAttributeValue("MoveToTop", true);
        projectPlanPhaseEnterpriseComponent.executeUpdate();
    }

    function handlePhaseMoveUp(projectPhaseUSID: string) {
        setProjectPlanFetchBackgroundOperation(true)
        const projectPlanPhaseEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanPhase")!
        projectPlanPhaseEnterpriseComponent.newEdit();
        projectPlanPhaseEnterpriseComponent.setAttributeValue("USID", projectPhaseUSID);
        projectPlanPhaseEnterpriseComponent.setAttributeValue("MoveUp", true);
        projectPlanPhaseEnterpriseComponent.executeUpdate();
    }

    function handlePhaseMoveDown(projectPhaseUSID: string) {
        setProjectPlanFetchBackgroundOperation(true)
        const projectPlanPhaseEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanPhase")!
        projectPlanPhaseEnterpriseComponent.newEdit();
        projectPlanPhaseEnterpriseComponent.setAttributeValue("USID", projectPhaseUSID);
        projectPlanPhaseEnterpriseComponent.setAttributeValue("MoveDown", true);
        projectPlanPhaseEnterpriseComponent.executeUpdate();
    }

    function handlePhaseMoveToBottom(projectPhaseUSID: string) {
        setProjectPlanFetchBackgroundOperation(true)
        const projectPlanPhaseEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanPhase")!
        projectPlanPhaseEnterpriseComponent.newEdit();
        projectPlanPhaseEnterpriseComponent.setAttributeValue("USID", projectPhaseUSID);
        projectPlanPhaseEnterpriseComponent.setAttributeValue("MoveToBottom", true);
        projectPlanPhaseEnterpriseComponent.executeUpdate();
    }

    function handleMilestoneMoveToTop(projectPhaseMilestoneUSID: string) {
        setProjectPlanFetchBackgroundOperation(true)
        const projectPlanPhaseMilestoneEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanPhaseMilestone")!
        projectPlanPhaseMilestoneEnterpriseComponent.newEdit();
        projectPlanPhaseMilestoneEnterpriseComponent.setAttributeValue("USID", projectPhaseMilestoneUSID);
        projectPlanPhaseMilestoneEnterpriseComponent.setAttributeValue("MoveToTop", true);
        projectPlanPhaseMilestoneEnterpriseComponent.executeUpdate();
    }

    function handleMilestoneMoveUp(projectPhaseMilestoneUSID: string) {
        setProjectPlanFetchBackgroundOperation(true)
        const projectPlanPhaseMilestoneEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanPhaseMilestone")!
        projectPlanPhaseMilestoneEnterpriseComponent.newEdit();
        projectPlanPhaseMilestoneEnterpriseComponent.setAttributeValue("USID", projectPhaseMilestoneUSID);
        projectPlanPhaseMilestoneEnterpriseComponent.setAttributeValue("MoveUp", true);
        projectPlanPhaseMilestoneEnterpriseComponent.executeUpdate();
    }

    function handleMilestoneMoveDown(projectPhaseMilestoneUSID: string) {
        setProjectPlanFetchBackgroundOperation(true)
        const projectPlanPhaseMilestoneEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanPhaseMilestone")!
        projectPlanPhaseMilestoneEnterpriseComponent.newEdit();
        projectPlanPhaseMilestoneEnterpriseComponent.setAttributeValue("USID", projectPhaseMilestoneUSID);
        projectPlanPhaseMilestoneEnterpriseComponent.setAttributeValue("MoveDown", true);
        projectPlanPhaseMilestoneEnterpriseComponent.executeUpdate();
    }

    function handleMilestoneMoveToBottom(projectPhaseMilestoneUSID: string) {
        setProjectPlanFetchBackgroundOperation(true)
        const projectPlanPhaseMilestoneEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanPhaseMilestone")!
        projectPlanPhaseMilestoneEnterpriseComponent.newEdit();
        projectPlanPhaseMilestoneEnterpriseComponent.setAttributeValue("USID", projectPhaseMilestoneUSID);
        projectPlanPhaseMilestoneEnterpriseComponent.setAttributeValue("MoveToBottom", true);
        projectPlanPhaseMilestoneEnterpriseComponent.executeUpdate();
    }

    useEffect(() => {
        const projectPlanEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!
        const projectPlanPhaseEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanPhase")!
        const projectPlanPhaseMilestoneEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanPhaseMilestone")!

        EventBus.components.addListener("primary-position-form-applet-cancel", onCancelHandler);
        EventBus.components.addListener("primary-position-form-applet-save", onCancelHandler);
        EventBus.components.addListener("primary-user-group-form-applet-cancel", onCancelHandler);
        EventBus.components.addListener("primary-user-group-form-applet-save", onCancelHandler);
        EventBus.components.addListener("primary-work-group-form-applet-cancel", onCancelHandler);
        EventBus.components.addListener("primary-work-group-form-applet-save", onCancelHandler);
        EventBus.components.addListener("secondary-position-form-applet-cancel", onCancelHandler);
        EventBus.components.addListener("secondary-position-form-applet-save", onCancelHandler);
        EventBus.components.addListener("secondary-user-group-form-applet-cancel", onCancelHandler);
        EventBus.components.addListener("secondary-user-group-form-applet-save", onCancelHandler);
        EventBus.components.addListener("project-plan-form-applet-cancel", onCancelHandler);
        EventBus.components.addListener("project-plan-form-applet-save", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-form-applet-cancel", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-form-applet-save", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-milestone-form-applet-cancel", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-milestone-form-applet-save", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-panel-close", onPhasePanelClose);
        EventBus.components.addListener("project-plan-phase-milestone-panel-close", onPhaseMilestonePanelClose);
        EventBus.components.addListener("project-plan-phase-milestone-delete-cancel", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-milestone-delete-save", onPhaseMilestoneDeleteSave);
        EventBus.components.addListener("project-plan-phase-milestone-form-new-applet-cancel", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-milestone-form-new-applet-save", onPhaseMilestoneNewSave);
        EventBus.components.addListener("project-plan-phase-delete-cancel", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-delete-save", onPhaseDeleteSave);
        EventBus.components.addListener("project-plan-delete-cancel", onCancelHandler);
        EventBus.components.addListener("project-plan-delete-save", onProjectPlanDeleteSave);
        EventBus.components.addListener("project-plan-phase-milestone-relocate-cancel", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-milestone-relocate-save", onProjectPlanPhaseMilestoneRelocateSave);
        EventBus.components.addListener("project-plan-phase-milestone-copy-save", onMilestoneCopy);
        EventBus.components.addListener("project-plan-phase-milestone-copy-cancel", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-copy-save", onPhaseCopy);
        EventBus.components.addListener("project-plan-phase-copy-cancel", onCancelHandler);
        EventBus.components.addListener("project-plan-copy-save", onPlanCopy);
        EventBus.components.addListener("project-plan-copy-cancel", onCancelHandler);

        setProjectPlanUSID(inboundProjectPlanUSID!);

        // @ts-ignore
        MemoryContext.components["ProjectPlanDetail-EO-ProjectPlanUSID"] = inboundProjectPlanUSID;

        projectPlanEnterpriseComponent.addInvalidListener(enterpriseComponentInvalidateCompletedListener);
        projectPlanPhaseEnterpriseComponent.addInsertCompletedListener(enterpriseComponentInsertCompletedListener);
        projectPlanPhaseEnterpriseComponent.addUpdateCompletedListener(enterpriseComponentUpdateCompletedListener);
        projectPlanPhaseMilestoneEnterpriseComponent.addUpdateCompletedListener(enterpriseComponentUpdateCompletedListener);

        adminPositionEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        adminUserGroupEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        projectPlanEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        projectPlanEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        projectPlanEnterpriseComponent.addUpdateCompletedListener(enterpriseComponentUpdateCompletedListener);

        enterpriseComponentInvalidateCompletedListener(projectPlanEnterpriseComponent)

        return () => {
            EventBus.components.removeListener("primary-position-form-applet-cancel", onCancelHandler);
            EventBus.components.removeListener("primary-position-form-applet-save", onCancelHandler);
            EventBus.components.removeListener("primary-user-group-form-applet-cancel", onCancelHandler);
            EventBus.components.removeListener("primary-user-group-form-applet-save", onCancelHandler);
            EventBus.components.removeListener("primary-work-group-form-applet-cancel", onCancelHandler);
            EventBus.components.removeListener("primary-work-group-form-applet-save", onCancelHandler);
            EventBus.components.removeListener("secondary-position-form-applet-cancel", onCancelHandler);
            EventBus.components.removeListener("secondary-position-form-applet-save", onCancelHandler);
            EventBus.components.removeListener("secondary-user-group-form-applet-cancel", onCancelHandler);
            EventBus.components.removeListener("secondary-user-group-form-applet-save", onCancelHandler);
            EventBus.components.removeListener("project-plan-form-applet-cancel", onCancelHandler);
            EventBus.components.removeListener("project-plan-form-applet-save", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-form-applet-cancel", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-form-applet-save", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-milestone-form-applet-cancel", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-milestone-form-applet-save", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-panel-close", onPhasePanelClose);
            EventBus.components.removeListener("project-plan-phase-milestone-panel-close", onPhaseMilestonePanelClose);
            EventBus.components.removeListener("project-plan-phase-milestone-delete-cancel", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-milestone-delete-save", onPhaseMilestoneDeleteSave);
            EventBus.components.removeListener("project-plan-phase-milestone-form-new-applet-cancel", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-milestone-form-new-applet-save", onPhaseMilestoneNewSave);
            EventBus.components.removeListener("project-plan-phase-delete-cancel", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-delete-save", onPhaseDeleteSave);
            EventBus.components.removeListener("project-plan-phase-delete-cancel", onCancelHandler);
            EventBus.components.removeListener("project-plan-delete-save", onProjectPlanDeleteSave);
            EventBus.components.removeListener("project-plan-phase-milestone-reallocate-cancel", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-milestone-reallocate-save", onProjectPlanPhaseMilestoneRelocateSave);
            EventBus.components.removeListener("project-plan-phase-milestone-copy-save", onMilestoneCopy);
            EventBus.components.removeListener("project-plan-phase-milestone-copy-cancel", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-copy-save", onPhaseCopy);
            EventBus.components.removeListener("project-plan-phase-copy-cancel", onCancelHandler);
            EventBus.components.removeListener("project-plan-copy-save", onPlanCopy);
            EventBus.components.removeListener("project-plan-copy-cancel", onCancelHandler);

            projectPlanEnterpriseComponent.removeInvalidListener(enterpriseComponentInvalidateCompletedListener);
            projectPlanPhaseEnterpriseComponent.removeInsertCompletedListener(enterpriseComponentInsertCompletedListener);
            projectPlanPhaseMilestoneEnterpriseComponent.removeInsertCompletedListener(enterpriseComponentInsertCompletedListener);
            projectPlanEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener);
            projectPlanEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);
            projectPlanEnterpriseComponent.removeUpdateCompletedListener(enterpriseComponentUpdateCompletedListener);
            projectPlanPhaseEnterpriseComponent.removeUpdateCompletedListener(enterpriseComponentUpdateCompletedListener);
            projectPlanPhaseMilestoneEnterpriseComponent.removeUpdateCompletedListener(enterpriseComponentUpdateCompletedListener);
            adminPositionEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);
            adminUserGroupEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        }

    }, [projectPlanEnterpriseObject, adminPositionEnterpriseComponent, adminUserGroupEnterpriseComponent]);

    useEffect(() => {
        adminPositionMembershipEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        adminPositionMembershipEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        adminPositionMembershipEnterpriseComponent.addInsertCompletedListener(enterpriseComponentInsertCompletedListener);
        adminPositionMembershipEnterpriseComponent.addDeleteCompletedListener(enterpriseComponentDeleteCompletedListener);
        adminPositionMembershipEnterpriseComponent.newQuery();
        adminPositionMembershipEnterpriseComponent.setAttributeValue("SourceUSID", inboundProjectPlanUSID);
        adminPositionMembershipEnterpriseComponent.setIDOCRequest("v1.AdminPositionMembership-002");
        adminPositionMembershipEnterpriseComponent.setIDOCResponse("v1.AdminPositionMembership-002");
        adminPositionMembershipEnterpriseComponent.executeQuery(1, 5);

        return () => {
            adminPositionMembershipEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener)
            adminPositionMembershipEnterpriseComponent.removeInsertCompletedListener(enterpriseComponentInsertCompletedListener)
            adminPositionMembershipEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener)
            adminPositionMembershipEnterpriseComponent.removeDeleteCompletedListener(enterpriseComponentDeleteCompletedListener)
        }
    }, [adminPositionMembershipEnterpriseComponent, inboundProjectPlanUSID]);

    useEffect(() => {
        adminUserGroupMembershipEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        adminUserGroupMembershipEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        adminUserGroupMembershipEnterpriseComponent.addDeleteCompletedListener(enterpriseComponentDeleteCompletedListener);
        adminUserGroupMembershipEnterpriseComponent.newQuery();
        adminUserGroupMembershipEnterpriseComponent.setAttributeValue("SourceUSID", inboundProjectPlanUSID);
        adminUserGroupMembershipEnterpriseComponent.setIDOCRequest("v1.AdminUserGroupMembership-002");
        adminUserGroupMembershipEnterpriseComponent.setIDOCResponse("v1.AdminUserGroupMembership-002");
        adminUserGroupMembershipEnterpriseComponent.executeQuery(1, 5);

        return () => {
            adminUserGroupMembershipEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener)
            adminUserGroupMembershipEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener)
            adminUserGroupMembershipEnterpriseComponent.removeDeleteCompletedListener(enterpriseComponentDeleteCompletedListener)
        }
    }, [adminUserGroupMembershipEnterpriseComponent, inboundProjectPlanUSID]);

    useEffect(() => {
        adminWorkGroupMembershipEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        adminWorkGroupMembershipEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        adminWorkGroupMembershipEnterpriseComponent.newQuery();
        adminWorkGroupMembershipEnterpriseComponent.setAttributeValue("SourceUSID", inboundProjectPlanUSID);
        adminWorkGroupMembershipEnterpriseComponent.setIDOCRequest("v1.AdminWorkGroupMembership-002");
        adminWorkGroupMembershipEnterpriseComponent.setIDOCResponse("v1.AdminWorkGroupMembership-002");
        adminWorkGroupMembershipEnterpriseComponent.executeQuery(1, 5);

        return () => {
            adminWorkGroupMembershipEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener)
            adminWorkGroupMembershipEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener)
        }
    }, [adminWorkGroupMembershipEnterpriseComponent, inboundProjectPlanUSID]);

    function onCancelHandler() {
        setShowEditPrimaryPosition(false)
        setShowEditPrimaryUserGroup(false)
        setShowEditPrimaryWorkGroup(false)
        setShowAddSecondaryPosition(false)
        setShowAddSecondaryUserGroup(false)
        setShowAddPhase(false)
        setShowAddPhaseMilestone(false)
        setShowEditPlan(false)
        setShowDeletePhaseMilestone(null)
        setShowDeletePhase(null)
        setShowDeletePlan(false)
        setShowMilestoneRelocate(null)
        setShowCopyMilestone(null)
        setShowCopyPhase(null)
        setShowCopyPlan(false)
    }

    function onProjectPlanDeleteSave() {
        navigate("/");
    }

    function onPhasePanelClose() {
        const projectPlanEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!
        projectPlanEnterpriseComponent.invalidate();
        setShowPanelForPhase(null);
    }

    function onPhaseMilestonePanelClose() {
        const projectPlanEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!
        projectPlanEnterpriseComponent.invalidate();
        setShowPanelForMilestone(null);
    }

    function onPhaseMilestoneNewSave() {
        const projectPlanEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!
        projectPlanEnterpriseComponent.invalidate();
        setShowAddPhaseMilestone(false);
    }

    function onMilestoneCopy() {
        const projectPlanEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!
        projectPlanEnterpriseComponent.invalidate();
        setShowCopyMilestone(null);
    }

    function onPhaseCopy() {
        const projectPlanEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!
        projectPlanEnterpriseComponent.invalidate();
        setShowCopyPhase(null);
    }

    function onPlanCopy() {
        setShowCopyPlan(false);
        navigate("/")
    }

    function onPhaseMilestoneDeleteSave() {
        const projectPlanEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!
        projectPlanEnterpriseComponent.invalidate();
        setShowDeletePhaseMilestone(null);
    }

    function onPhaseDeleteSave() {
        const projectPlanEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!
        projectPlanEnterpriseComponent.invalidate();
        setShowDeletePhase(null);
    }

    function onProjectPlanPhaseMilestoneRelocateSave() {
        const projectPlanEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!
        projectPlanEnterpriseComponent.invalidate();
        setShowMilestoneRelocate(null)
    }

    function renderProjectPhases() {
        if (projectPlanBuffer.size === 0) return null;

        let phases: any[] = projectPlanBuffer.get("ProjectPlanPhases")

        let newPhases: any[] = [];
        let _phases: any[] = structuredClone(projectPlanBuffer.get("ProjectPlanPhases"))
        for (let i = 0; i < _phases.length; i++) {
            let _phase = _phases[i];
            for (let j = 0; j < _phase.ListOfProjectPlanPhaseMilestone.ProjectPlanPhaseMilestone.length; j++) {
                let _milestone = _phase.ListOfProjectPlanPhaseMilestone.ProjectPlanPhaseMilestone[j];
                _milestone["Marked"] = false;
                for (let k = 0; k < _milestone.ListOfProjectPlanPhaseMilestoneEmployee.ProjectPlanPhaseMilestoneEmployee.length; k++) {
                    let employee = _milestone.ListOfProjectPlanPhaseMilestoneEmployee.ProjectPlanPhaseMilestoneEmployee[k]
                    if (showMyMilestones) {
                        if (employee.EmployeeUSID === sessionContext.getEmployeeUSID()) {
                            _milestone["Marked"] = true
                            _phase["Marked"] = true
                        }
                    } else if (showMilestonesByAssigneeUSID) {
                        if (employee.EmployeeUSID === showMilestonesByAssigneeUSID) {
                            _milestone["Marked"] = true
                            _phase["Marked"] = true
                        }
                    }
                }
            }
        }

        for (let i = 0; i < _phases.length; i++) {
            let _phase = _phases[i];
            if (_phase.Marked === true) {
                let _p = structuredClone(_phase);
                delete _p["ListOfProjectPlanPhaseMilestone"]
                _p["ListOfProjectPlanPhaseMilestone"] = {}
                _p.ListOfProjectPlanPhaseMilestone["ProjectPlanPhaseMilestone"] = []

                for (let j = 0; j < _phase.ListOfProjectPlanPhaseMilestone.ProjectPlanPhaseMilestone.length; j++) {
                    let _milestone = _phase.ListOfProjectPlanPhaseMilestone.ProjectPlanPhaseMilestone[j];
                    if (_milestone["Marked"] === true) {
                        _p.ListOfProjectPlanPhaseMilestone.ProjectPlanPhaseMilestone.push(_milestone)
                    }
                }
                newPhases.push(_p);
            }
        }

        if (showMyMilestones || showMilestonesByAssigneeUSID) {
            phases = newPhases;
        }
        let content = [];

        for (let i = 0; i < phases.length; i++) {
            content.push(
                <div key={i + 'phase'}>
                    <div key={i + 'phase'} style={{display: "flex", flexDirection: "row", width: "100%", height: "50px", backgroundColor: "#EDEFF3", borderTop: "1px solid #D8DDE4", overflow: "clip"}}>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", borderRight: "1px solid #D8DDE4"}}>
                            <div style={{border: "2px solid #000000", borderRadius: "4px", width: "12px", height: "12px", marginTop: "17px", marginLeft: "13px"}}>
                                <IconButton className={css_pages.DropdownButton} onClick={() => {
                                    let newPhaseExpansion: Map<string, PhaseExpansion> = structuredClone(phaseExpansion);
                                    let phaseExpansionToUpdate = newPhaseExpansion.get(phases[i].USID)
                                    if (phaseExpansionToUpdate === undefined) {
                                        newPhaseExpansion.set(phases[i].USID, {ProjectPhaseUSID: phases[i].USID, Expanded: false});
                                    } else {
                                        newPhaseExpansion.set(phases[i].USID, {ProjectPhaseUSID: phases[i].USID, Expanded: !phaseExpansion.get(phases[i].USID)!.Expanded})
                                    }
                                    setPhaseExpansion(newPhaseExpansion)
                                }}>
                                    {phaseExpansion.get(phases[i].USID) !== undefined && !phaseExpansion.get(phases[i].USID)!.Expanded ? (
                                        <KeyboardArrowDown sx={{width: "14px", height: "14px", marginTop: "-2px"}}/>
                                    ) : (
                                        <KeyboardArrowUp sx={{width: "14px", height: "14px", marginTop: "-2px"}}/>
                                    )}
                                </IconButton>
                            </div>
                            <div style={{width: "232px", marginTop: "6px"}}>
                                <Button className={css_buttons.milestoneButton} onClick={() => {

                                    // @ts-ignore
                                    MemoryContext.components["ProjectPlanDetail-EO-ProjectPlanUSID"] = inboundProjectPlanUSID;
                                    // @ts-ignore
                                    MemoryContext.components["ProjectPlanDetail-EO-PhaseUSID"] = phases[i].USID;

                                    for (let t = 0; t < projectPlanBuffer.get("ProjectPlanPhases").length; t++) {
                                        let _phase = projectPlanBuffer.get("ProjectPlanPhases")[t];

                                        for (let u = 0; u < _phase["ListOfProjectPlanPhaseMilestone"]["ProjectPlanPhaseMilestone"].length; u++) {
                                            let _milestone = _phase["ListOfProjectPlanPhaseMilestone"]["ProjectPlanPhaseMilestone"][u];

                                            _milestone.Highlight = false;
                                        }
                                    }
                                    setShowPanelForPhase(phases[i]);
                                }}>
                                    {phases[i].Status === null ? (
                                        <Tooltip title={phases[i].Name}>
                                            <Typography style={{margin: "0 0 0 6px", fontSize: "16px", fontWeight: 500, color: "#000000", whiteSpace: "nowrap", overflow: "hidden", width: "480px", display: "block", height: "20px", textOverflow: "ellipsis"}}>{phases[i].Name}</Typography>
                                        </Tooltip>
                                    ) : (
                                        <Tooltip title={phases[i].Name}>
                                            <Typography style={{margin: "0 0 0 6px", fontSize: "16px", fontWeight: 500, color: "#000000", whiteSpace: "nowrap", overflow: "hidden", width: "220px", display: "block", height: "20px", textOverflow: "ellipsis"}}>{phases[i].Name}</Typography>
                                        </Tooltip>
                                    )}
                                </Button>
                            </div>
                            {phases[i].Status !== null ? (
                                <div style={{width: "120px", paddingLeft: "5px", paddingTop: "10px"}}>
                                    <Chip label={phases[i].Status} size="small" style={{border: "1px solid #B26000", fontSize: 12, marginTop: "3px", backgroundColor: "#FEF8EE", color: "#B26000"}}/>
                                </div>
                            ): (
                                <div style={{width: "120px", paddingLeft: "5px", paddingTop: "10px"}}>
                                </div>
                            )}
                            <div style={{paddingLeft: "3px", paddingTop: "11px", width: "105px"}}>
                                <Typography style={{margin: "4px 0 0 12px", fontSize: "14px", fontWeight: 400, color: "#000000"}}>{formatLocalDate(phases[i].DueDatetime)}</Typography>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", minWidth: "118px", width: "118px", border: "0px solid #D8DDE4"}}>
                                <div style={{margin: "auto 0 auto 0"}}>
                                    <IconButton className={css_buttons.milestoneDeleteButton} onClick={() => {setShowCopyPhase(phases[i])}}>
                                        <ContentCopy sx={{marginLeft: "27px", width: "20px", height: "20px"}}/>
                                    </IconButton>
                                </div>
                                <div style={{margin: "auto 0 auto 0"}}>
                                    <Tooltip title={!hasPrivilege("DELETE_PHASE", inboundProjectPlanUSID!) ? "This phase cannot be deleted because you do not have the 'DELETE_PHASE' privilege." : phases[i].Status === "DONE" ? "This phase cannot be deleted because the status of the phase is 'DONE'." : 'Delete Phase'}>
                                        <IconButton className={css_buttons.milestoneDeleteButton} style={{color: !hasPrivilege("DELETE_MILESTONE", inboundProjectPlanUSID!) || phases[i].Status === "DONE" ? "#F1C40F" : "#1498D8"}} onClick={() => {
                                            if (!hasPrivilege("DELETE_PHASE", inboundProjectPlanUSID!) || phases[i].Status === "DONE")  {
                                                // do nothing
                                            } else {
                                                setShowDeletePhase(phases[i])
                                            }
                                        }}>
                                            <Delete sx={{marginLeft: "0px", width: "20px", height: "20px"}}/>
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                <IconButton className={css_pages.DropdownButton} onClick={(event) => {
                                    setShowPhaseOptionMenu(phases[i].USID)
                                    setPhaseOptionMenuAnchor(event.currentTarget)
                                }}>
                                    <MoreVert sx={{marginTop: "15px", width: "20px", height: "20px", color: "#7B8291"}}/>
                                </IconButton>
                                <Popover
                                    open={showPhaseOptionMenu === phases[i].USID}
                                    anchorEl={phaseOptionMenuAnchor}
                                    id={phases[i].USID}
                                    anchorOrigin={{
                                        vertical: 'center',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'center',
                                        horizontal: 'left',
                                    }}
                                    onClose={() => {
                                        setShowPhaseOptionMenu(null);
                                        setPhaseOptionMenuAnchor(null)
                                    }}
                                >
                                    <div style={{display: "flex", flexDirection: "column", paddingLeft: "10px", paddingTop: "10px", width: "29px"}}>
                                        <div>
                                            <Tooltip title={"Move to top"}>
                                                <IconButton className={css_pages.DropdownButton} disabled={i === 0} onClick={() => {
                                                    setShowPhaseOptionMenu(null);
                                                    setPhaseOptionMenuAnchor(null)
                                                    handlePhaseMoveToTop(phases[i].USID)
                                                }}>
                                                    <VerticalAlignTop sx={{width: "20px", height: "20px", color: i === 0 ? "#D8DDE4" : "#7B8291"}}/>
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                        <div>
                                            <Tooltip title={"Move up"}>
                                                <IconButton className={css_pages.DropdownButton} disabled={i === 0} onClick={() => {
                                                    setShowPhaseOptionMenu(null);
                                                    setPhaseOptionMenuAnchor(null)
                                                    handlePhaseMoveUp(phases[i].USID)
                                                }}>
                                                    <North sx={{width: "20px", height: "20px", color: i === 0 ? "#D8DDE4" : "#7B8291"}}/>
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                        <div>
                                            <Tooltip title={"Move down"}>
                                                <IconButton className={css_pages.DropdownButton} disabled={i === phases.length - 1} onClick={() => {
                                                    setShowPhaseOptionMenu(null);
                                                    setPhaseOptionMenuAnchor(null)
                                                    handlePhaseMoveDown(phases[i].USID)
                                                }}>
                                                    <South sx={{width: "20px", height: "20px", color: i === phases.length - 1 ? "#D8DDE4" : "#7B8291"}}/>
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                        <div>
                                            <Tooltip title={"Move to bottom"}>
                                                <IconButton className={css_pages.DropdownButton} disabled={i === phases.length - 1} onClick={() => {
                                                    setShowPhaseOptionMenu(null);
                                                    setPhaseOptionMenuAnchor(null)
                                                    handlePhaseMoveToBottom(phases[i].USID)
                                                }}>
                                                    <VerticalAlignBottom sx={{width: "20px", height: "20px", color: i === phases.length - 1 ? "#D8DDE4" : "#7B8291"}}/>
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </Popover>
                            </div>
                        </div>
                        {renderProjectPhaseRow(phases[i])}
                    </div>
                    {renderProjectPhaseMilestones(phases[i])}
                </div>
            )
        }

        return (
            <div style={{display: "flex", flexDirection: "row", width: "100%"}}>
                {showAlphabetFilter ? (
                    <div style={{display: "flex", flexDirection: "column", minWidth: "25px"}}>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'A').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {
                                    setQuickFilter("A");
                                    projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!.invalidate();
                                }}>
                                    <Typography>A</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'B').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("B")}}>
                                    <Typography>B</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'C').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("C")}}>
                                    <Typography>C</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'D').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("D")}}>
                                    <Typography>D</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'E').length + " occurrence"}>
                               <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("E")}}>
                                    <Typography>E</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'F').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("F")}}>
                                    <Typography>F</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'G').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("G")}}>
                                    <Typography>G</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'H').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("H")}}>
                                    <Typography>H</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'I').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("I")}}>
                                    <Typography>I</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'J').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("J")}}>
                                    <Typography>J</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'K').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("K")}}>
                                    <Typography>K</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'L').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("L")}}>
                                    <Typography>L</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'M').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("M")}}>
                                    <Typography>M</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'N').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("N")}}>
                                    <Typography>N</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'O').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("O")}}>
                                    <Typography>O</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'P').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("P")}}>
                                    <Typography>P</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'Q').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("Q")}}>
                                    <Typography>Q</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'R').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("R")}}>
                                    <Typography>R</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'S').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("S")}}>
                                    <Typography>S</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'T').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("T")}}>
                                    <Typography>T</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'U').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("U")}}>
                                    <Typography>U</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'V').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("V")}}>
                                    <Typography>V</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'W').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("W")}}>
                                    <Typography>W</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'X').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("X")}}>
                                    <Typography>X</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'Y').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("Y")}}>
                                    <Typography>Y</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Tooltip title={" " + phases.filter(x => x.Name[0].toUpperCase() === 'Z').length + " occurrence"}>
                                <Button className={css_buttons.alphabet} onClick={() => {setQuickFilter("Z")}}>
                                    <Typography>Z</Typography>
                                </Button>
                            </Tooltip>
                        </div>
                        <div style={{borderTop: "1px solid #EDEFF3", borderLeft: "1px solid #EDEFF3", borderRight: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 0 5px"}}>
                            <Button className={css_buttons.alphabet} onClick={() => {
                                setQuickFilter(null);
                                projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!.invalidate();
                            }}>
                                <Typography>*</Typography>
                            </Button>
                        </div>
                    </div>
                ) : null}
                <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
                    {content}
                </div>
            </div>
        )
    }

    function renderYearCellForPhase(month: string, phase: any) {
        if (phase.DueDatetime === null) return null;

        let datetime = moment.utc(phase.DueDatetime)

        if (datetime.format("MMM") === month && datetime.format("YYYY") === referenceTimestamp.format("YYYY")) {
            if (phase.Status === "DONE") {
                return (
                    <Tooltip title={"DONE"}><Circle sx={{color: "#00A044"}}/></Tooltip>
                )
            } else if (phase.Status === "IN PROGRESS" || phase.Status === "IN REVIEW") {
                return <Tooltip title={"IN PROGRESS"}><Circle sx={{color: "#B26000"}}/></Tooltip>
            } else if (phase.DueDatetime !== null) {
                return <Tooltip title={"Phase Due Date is set, No references added"}><CircleOutlined sx={{color: "#B26000"}}/></Tooltip>
            }
        }
        return null;
    }

    function renderQuarterCellForPhase(quarter: number, phase: any) {
        if (phase.DueDatetime === null) return null;

        let datetime = moment.utc(phase.DueDatetime)

        if (datetime.quarter() === quarter) {
            if (phase.Status === "DONE") {
                return <Tooltip title={"DONE"}><Circle sx={{color: "#00A044"}}/></Tooltip>
            } else if (phase.Status === "IN PROGRESS") {
                return <Tooltip title={"IN PROGRESS"}><Circle sx={{color: "#B26000"}}/></Tooltip>
            } else if (phase.DueDatetime !== null) {
                return <Tooltip title={"Phase Due Date is set, No references added"}><CircleOutlined sx={{color: "#B26000"}}/></Tooltip>
            }
        }
        return null;
    }

    function renderMonthCellForPhase(year: string, month: string, date: number, phase: any) {
        if (phase.DueDatetime === null) return null;

        let datetime = moment(phase.DueDatetime)

        if (datetime.format("YYYY") === year && datetime.format("MMM") === month && datetime.date() === date) {
            if (phase.Status === "DONE") {
                return <Tooltip title={"DONE"}><Circle sx={{color: "#00A044"}}/></Tooltip>
            } else if (phase.Status === "IN PROGRESS") {
                return <Tooltip title={"IN PROGRESS"}><Circle sx={{color: "#B26000"}}/></Tooltip>
            } else if (phase.DueDatetime !== null) {
                return <Tooltip title={"Phase Due Date is set, No references added"}><CircleOutlined sx={{color: "#B26000"}}/></Tooltip>
            }
        }
        return null;
    }

    function renderWeekCellForPhase(year: string, month: string, date: number, phase: any) {
        if (phase.DueDatetime === null) return null;

        let datetime = moment(phase.DueDatetime)

        if (datetime.format("YYYY") === year && datetime.format("MMM") === month && datetime.date() === date) {
            if (phase.Status === "DONE") {
                return <Tooltip title={"DONE"}><Circle sx={{color: "#00A044"}}/></Tooltip>
            } else if (phase.Status === "IN PROGRESS") {
                return <Tooltip title={"IN PROGRESS"}><Circle sx={{color: "#B26000"}}/></Tooltip>
            } else if (phase.DueDatetime !== null) {
                return <Tooltip title={"Phase Due Date is set, No references added"}><CircleOutlined sx={{color: "#B26000"}}/></Tooltip>
            }
        }
        return null;
    }

    function renderYearCellForMilestone(month: string, milestone: any) {
        if (milestone.DueDatetime === null) return null;

        let datetime = moment.utc(milestone.DueDatetime)

        if (datetime.format("MMM") === month && datetime.format("YYYY") === referenceTimestamp.format("YYYY")) {
            if (milestone.Status === "DONE") {
                return <Tooltip title={"DONE"}><FontAwesomeIcon icon={faDiamond} style={{color: "#00A044", width: "22px", height: "22px", marginTop: "2px"}}/></Tooltip>
            } else if (milestone.Status === "IN PROGRESS") {
                return <Tooltip title={"IN PROGRESS"}><FontAwesomeIcon icon={faDiamond} style={{color: "#B26000", width: "22px", height: "22px", marginTop: "2px"}}/></Tooltip>
            } else if (milestone.DueDatetime !== null) {
                return <Tooltip title={"Milestone Due Date is set, No references added"}><FontAwesomeIcon icon={faDiamondRegular} style={{color: "#B26000", width: "22px", height: "22px", marginTop: "2px"}}/></Tooltip>
            }
        }
        return null;
    }

    function renderQuarterCellForMilestone(quarter: number, milestone: any) {
        if (milestone.DueDatetime === null) return null;

        let datetime = moment.utc(milestone.DueDatetime)

        if (datetime.quarter() === quarter) {
            if (milestone.Status === "DONE") {
                return <Tooltip title={"DONE"}><FontAwesomeIcon icon={faDiamond} style={{color: "#00A044", width: "22px", height: "22px", marginTop: "2px"}}/></Tooltip>
            } else if (milestone.Status === "IN PROGRESS") {
                return <Tooltip title={"IN PROGRESS"}><FontAwesomeIcon icon={faDiamond} style={{color: "#B26000", width: "22px", height: "22px", marginTop: "2px"}}/></Tooltip>
            } else if (milestone.DueDatetime !== null) {
                return <Tooltip title={"Milestone Due Date is set, No references added"}><FontAwesomeIcon icon={faDiamondRegular} style={{color: "#B26000", width: "22px", height: "22px", marginTop: "2px"}}/></Tooltip>
            }
        }
        return null;
    }

    function renderMonthCellForMilestone(year: string, month: string, date: number, milestone: any) {
        if (milestone.DueDatetime === null) return null;

        let datetime = moment(milestone.DueDatetime)

        if (datetime.format("YYYY") === year && datetime.format("MMM") === month && datetime.date() === date) {
            if (milestone.Status === "DONE") {
                return <Tooltip title={"DONE"}><FontAwesomeIcon icon={faDiamond} style={{color: "#00A044", width: "22px", height: "22px", marginTop: "2px"}}/></Tooltip>
            } else if (milestone.Status === "IN PROGRESS") {
                return <Tooltip title={"IN PROGRESS"}><FontAwesomeIcon icon={faDiamond} style={{color: "#B26000", width: "22px", height: "22px", marginTop: "2px"}}/></Tooltip>
            } else if (milestone.DueDatetime !== null) {
                return <Tooltip title={"Milestone Due Date is set, No references added"}><FontAwesomeIcon icon={faDiamondRegular} style={{color: "#B26000", width: "22px", height: "22px", marginTop: "2px"}}/></Tooltip>
            }
        }
        return null;
    }

    function renderWeekCellForMilestone(year: string, month: string, date: number, milestone: any) {
        if (milestone.DueDatetime === null) return null;

        let datetime = moment(milestone.DueDatetime)

        if (datetime.format("YYYY") === year && datetime.format("MMM") === month && datetime.date() === date) {
            if (milestone.Status === "DONE") {
                return <Tooltip title={"DONE"}><FontAwesomeIcon icon={faDiamond} style={{color: "#00A044", width: "22px", height: "22px", marginTop: "2px"}}/></Tooltip>
            } else if (milestone.Status === "IN PROGRESS") {
                return <Tooltip title={"IN PROGRESS"}><FontAwesomeIcon icon={faDiamond} style={{color: "#B26000", width: "22px", height: "22px", marginTop: "2px"}}/></Tooltip>
            } else if (milestone.DueDatetime !== null) {
                return <Tooltip title={"Milestone Due Date is set, No references added"}><FontAwesomeIcon icon={faDiamondRegular} style={{color: "#B26000", width: "22px", height: "22px", marginTop: "2px"}}/></Tooltip>
            }
        }
        return null;
    }

    function renderProjectPhaseRow(phase: any) {
        if (timePerspective === "Year") {
            return renderYearForPhaseRow(phase);
        }
        if (timePerspective === "Quarter") {
            return renderQuarterForPhaseRow(phase);
        }
        if (timePerspective === "Month") {
            return renderMonthForPhaseRow(phase);
        }
        if (timePerspective === "Week") {
            return renderWeekForPhaseRow(phase);
        }
    }

    function renderYearForPhaseRow(phase: any) {
        let counter = moment(`${referenceTimestamp.format("YYYY")}-01-01`, 'YYYY-MM-DD')

        let rows = [];
        for (let i = 0; i < 12; i++) {
            rows.push(
                <div key={i} style={{display: "flex", flexDirection: "row", justifyContent: "center", paddingTop: "11px", width: yearCellWidth, borderRight: "1px solid #D8DDE4"}}>
                    {renderYearCellForPhase(counter.format("MMM"), phase)}
                </div>
            )
            counter = counter.add(1, 'month')
        }
        return (
            <div style={{display: "flex", flexDirection: "row", width: "1170px", minWidth: "1170px", maxWidth: "1170px"}}>
                {rows}
            </div>
        );
    }

    function renderQuarterForPhaseRow(phase: any) {
        let counter = moment(referenceTimestamp)

        let rows = [];
        for (let i = 0; i < 4; i++) {
            rows.push(
                <div style={{display: "flex", flexDirection: "row", justifyContent: "center", width: "292px", paddingTop: "11px", borderRight: "1px solid #D8DDE4"}}>
                    {renderQuarterCellForPhase(counter.quarter(), phase)}
                </div>
            )
            counter.add(1, 'quarters')
        }

        return (
            <div style={{display: "flex", flexDirection: "row", width: "1170px", minWidth: "1170px", maxWidth: "1170px"}}>
                {rows}
            </div>
        );
    }

    function renderMonthForPhaseRow(phase: any) {
        let reference = referenceTimestamp;
        let counter = moment(`${referenceTimestamp.format("YYYY")}-${referenceTimestamp.format("MM")}-01`, 'YYYY-MM-DD')
        let monthCellWidth = "px";
        let daysInMonth = reference.daysInMonth();

        if (daysInMonth === 28) {
            monthCellWidth = "41px"
        }
        if (daysInMonth === 29) {
            monthCellWidth = "41px"
        }
        if (daysInMonth === 30) {
            monthCellWidth = "41px"
        }
        if (daysInMonth === 31) {
            monthCellWidth = "40px"
        }

        let rows = [];
        for (let i = 0; i < daysInMonth; i++) {
            rows.push(
                <div key={i} style={{display: "flex", flexDirection: "row", justifyContent: "center", width: monthCellWidth, paddingTop: "11px", borderRight: "1px solid #D8DDE4", height: "50px"}}>
                    {renderMonthCellForPhase(counter.format("YYYY"), counter.format("MMM"), counter.date(), phase)}
                </div>
            )
            counter = counter.add(1, 'day')
        }

        return (
            <>
                <div style={{display: "flex", flexDirection: "row", width: "1170px", minWidth: "1170px", maxWidth: "1170px", marginTop: "0px", height: "35px"}}>
                    {rows}
                </div>
            </>
        )
    }

    function renderWeekForPhaseRow(phase: any) {
        let reference = moment(referenceTimestamp)
        let counter = reference.clone().weekday(1);
        let weekPhaseCellWidth = "167px";

        let rows = [];
        for (let i = 0; i < 7; i++) {
            rows.push(
                <div style={{display: "flex", flexDirection: "row", justifyContent: "center", width: weekPhaseCellWidth, paddingTop: "11px", borderRight: "1px solid #D8DDE4"}}>
                    {renderWeekCellForPhase(counter.format("YYYY"), counter.format("MMM"), counter.date(), phase)}
                </div>
            )
            counter.add(1, 'day')
        }

        return (
            <div style={{display: "flex", flexDirection: "row", width: "1170px", minWidth: "1170px", maxWidth: "1170px"}}>
                {rows}
            </div>
        );
    }

    function renderProjectPhaseMilestoneRow(milestone: any) {
        if (timePerspective === "Year") {
            return renderYearForMilestoneRow(milestone);
        }
        if (timePerspective === "Quarter") {
            return renderQuarterForMilestoneRow(milestone);
        }
        if (timePerspective === "Month") {
            return renderMonthForMilestoneRow(milestone);
        }
        if (timePerspective === "Week") {
            return renderWeekForMilestoneRow(milestone);
        }
    }

    function renderYearForMilestoneRow(milestone: any) {
        let counter = moment(`${referenceTimestamp.format("YYYY")}-01-01`, 'YYYY-MM-DD')

        let rows = [];
        for (let i = 0; i < 12; i++) {
            rows.push(
                <div key={i} style={{display: "flex", flexDirection: "row", justifyContent: "center", paddingTop: "10px", width: yearCellWidth, borderRight: "1px solid #D8DDE4"}}>
                    {renderYearCellForMilestone(counter.format("MMM"), milestone)}
                </div>
            )
            counter = counter.add(1, 'month')
        }
        return (
            <div style={{display: "flex", flexDirection: "row", width: "1170px", minWidth: "1170px", maxWidth: "1170px"}}>
                {rows}
            </div>
        );
    }

    function renderQuarterForMilestoneRow(milestone: any) {
        let counter = moment(referenceTimestamp)

        let rows = [];
        for (let i = 0; i < 4; i++) {
            rows.push(
                <div style={{display: "flex", flexDirection: "row", justifyContent: "center", width: "292px", paddingTop: "11px", borderRight: "1px solid #D8DDE4"}}>
                    {renderQuarterCellForMilestone(counter.quarter(), milestone)}
                </div>
            )
            counter.add(1, 'quarters')
        }

        return (
            <div style={{display: "flex", flexDirection: "row", width: "1170px", minWidth: "1170px", maxWidth: "1170px"}}>
                {rows}
            </div>
        );
    }

    function renderMonthForMilestoneRow(milestone: any) {
        let reference = referenceTimestamp;
        let counter = moment(`${referenceTimestamp.format("YYYY")}-${referenceTimestamp.format("MM")}-01`, 'YYYY-MM-DD')
        let monthMilestoneCellWidth = "px";
        let daysInMonth = reference.daysInMonth();

        if (daysInMonth === 28) {
            monthMilestoneCellWidth = "41px"
        }
        if (daysInMonth === 29) {
            monthMilestoneCellWidth = "41px"
        }
        if (daysInMonth === 30) {
            monthMilestoneCellWidth = "41px"
        }
        if (daysInMonth === 31) {
            monthMilestoneCellWidth = "40px"
        }

        let rows = [];
        for (let i = 0; i < daysInMonth; i++) {
            rows.push(
                <div key={i} style={{display: "flex", flexDirection: "row", justifyContent: "center", width: monthMilestoneCellWidth, paddingTop: "11px", borderRight: "1px solid #D8DDE4", height: "50px"}}>
                    {renderMonthCellForMilestone(counter.format("YYYY"), counter.format("MMM"), counter.date(), milestone)}
                </div>
            )
            counter = counter.add(1, 'day')
        }

        return (
            <>
                <div style={{display: "flex", flexDirection: "row", width: "1170px", minWidth: "1170px", maxWidth: "1170px", marginTop: "0px", height: "35px"}}>
                    {rows}
                </div>
            </>
        )
    }

    function renderWeekForMilestoneRow(milestone: any) {
        let reference = moment(referenceTimestamp)
        let counter = reference.clone().weekday(1);
        let weekPhaseCellWidth = "167px";

        let rows = [];
        for (let i = 0; i < 7; i++) {
            rows.push(
                <div style={{display: "flex", flexDirection: "row", justifyContent: "center", width: weekPhaseCellWidth, paddingTop: "11px", borderRight: "1px solid #D8DDE4"}}>
                    {renderWeekCellForMilestone(counter.format("YYYY"), counter.format("MMM"), counter.date(), milestone)}
                </div>
            )
            counter.add(1, 'day')
        }

        return (
            <div style={{display: "flex", flexDirection: "row", width: "1170px", minWidth: "1170px", maxWidth: "1170px"}}>
                {rows}
            </div>
        );
    }

    function renderProjectPhaseMilestones(phase: any) {
        if (phaseExpansion.get(phase.USID) === undefined) {
        } else if (phaseExpansion.get(phase.USID)!.Expanded) {
        } else {
            return null;
        }

        let milestones: any[] = phase["ListOfProjectPlanPhaseMilestone"]["ProjectPlanPhaseMilestone"]

        let content = [];

        for (let i = 0; i < milestones.length; i++) {
            content.push(
                <div key={i + 1000} style={{display: "flex", flexDirection: "row", width: "100%", height: "50px", backgroundColor: "#FFFFFF", borderTop: "1px solid #D8DDE4", overflow: "clip"}}>
                    <div style={{display: "flex", flexDirection: "row", border: milestones[i].Highlight ? "1px solid #0000FF" : "0px solid #D8DDE4", borderRight: milestones[i].Highlight ? "1px solid #0000FF" : "1px solid #D8DDE4", backgroundColor: "#FFFFFF"}}>
                        <div style={{width: "5px", backgroundColor: "#D8DDE4"}}>
                        </div>
                        <div style={{width: "230px", marginLeft: "24px", marginTop: "17px"}}>
                            <Button className={css_buttons.milestoneButton} onClick={() => {
                                // @ts-ignore
                                MemoryContext.components["ProjectPlanDetail-EO-ProjectPlanUSID"] = inboundProjectPlanUSID;
                                // @ts-ignore
                                MemoryContext.components["ProjectPlanDetail-EO-PhaseUSID"] = phase.USID;
                                // @ts-ignore
                                MemoryContext.components["ProjectPlanDetail-EO-MilestoneUSID"] = milestones[i].USID;

                                for (let t = 0; t < projectPlanBuffer.get("ProjectPlanPhases").length; t++) {
                                    let _phase = projectPlanBuffer.get("ProjectPlanPhases")[t];

                                    for (let u = 0; u < _phase["ListOfProjectPlanPhaseMilestone"]["ProjectPlanPhaseMilestone"].length; u++) {
                                        let _milestone = _phase["ListOfProjectPlanPhaseMilestone"]["ProjectPlanPhaseMilestone"][u];

                                        _milestone.Highlight = false;
                                    }
                                }
                                milestones[i].Highlight = true;
                                setShowPanelForMilestone(milestones[i]);
                            }}>
                                {milestones[i].Status === null ? (
                                    <Tooltip title={milestones[i].Name}>
                                        <Typography style={{margin: "0 0 0 6px", fontSize: "14px", fontWeight: 400, color: "#000000", whiteSpace: "nowrap", overflow: "hidden", width: "480px", display: "block", height: "40px", textOverflow: "ellipsis"}}>{milestones[i].Name}</Typography>
                                    </Tooltip>
                                ) : (
                                    <Tooltip title={milestones[i].Name}>
                                        <Typography style={{margin: "0 0 0 6px", fontSize: "14px", fontWeight: 400, color: "#000000", whiteSpace: "nowrap", overflow: "hidden", width: "220px", display: "block", height: "40px", textOverflow: "ellipsis"}}>{milestones[i].Name}</Typography>
                                    </Tooltip>
                                )}
                            </Button>
                        </div>
                        <div style={{width: "120px", paddingLeft: "5px", paddingTop: "10px"}}>
                            {milestones[i].Status !== null ? (
                                <Chip label={milestones[i].Status} size="small" style={{border: "1px solid #B26000", fontSize: 12, marginTop: "3px", backgroundColor: "#FEF8EE", color: "#B26000"}}/>
                            ) : null}
                        </div>
                        <div style={{paddingLeft: "5px", paddingTop: "11px", width: "105px"}}>
                            <Typography style={{margin: "4px 0 0 10px", fontSize: "14px", fontWeight: 400, color: "#000000"}}>{formatLocalDate(milestones[i].DueDatetime)}</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", minWidth: "118px", width: "118px", border: "0px solid #D8DDE4"}}>
                            <div style={{margin: "auto 0 auto 0"}}>
                                <IconButton className={css_buttons.milestoneDeleteButton} onClick={() => {setShowCopyMilestone(milestones[i])}}>
                                    <ContentCopy sx={{marginLeft: "27px", width: "20px", height: "20px"}}/>
                                </IconButton>
                            </div>
                            <div style={{margin: "auto 0 auto 0"}}>
                                <Tooltip title={!hasPrivilege("DELETE_MILESTONE", inboundProjectPlanUSID!) ? "This milestone cannot be deleted because you do not have the 'DELETE_MILESTONE' privilege." : phase.Status === "DONE" ? "This milestone cannot be deleted because the status of the phase is 'DONE'." : milestones[i].Status === "DONE" ? "This milestone cannot be deleted because its status is 'DONE'" : 'Delete Milestone'}>
                                    <IconButton className={css_buttons.milestoneDeleteButton} style={{color: !hasPrivilege("DELETE_MILESTONE", inboundProjectPlanUSID!) || phase.Status === "DONE" || milestones[i].Status === "DONE" ? "#F1C40F" : "#1498D8"}} onClick={() => {
                                        if (!hasPrivilege("DELETE_MILESTONE", inboundProjectPlanUSID!) || phase.Status === "DONE" || milestones[i].Status === "DONE")  {
                                            // do nothing
                                        } else {
                                            setShowDeletePhaseMilestone(milestones[i])
                                        }
                                    }}>
                                        <Delete sx={{marginLeft: "0px", width: "20px", height: "20px"}}/>
                                    </IconButton>
                                </Tooltip>
                            </div>
                            <div style={{width: "19px", height: "50px"}}>
                                <IconButton className={css_buttons.verticalButton} style={{height: "50px"}} onClick={(event) => {
                                     setShowMilestoneOptionMenu(milestones[i].USID)
                                     setMilestoneOptionMenuAnchor(event.currentTarget)
                                }}>
                                    <MoreVert sx={{marginTop: "0", width: "20px", height: "20px", color: "#7B8291"}}/>
                                </IconButton>
                                <Popover
                                    open={showMilestoneOptionMenu === milestones[i].USID}
                                    anchorEl={milestoneOptionMenuAnchor}
                                    id={milestones[i].USID}
                                    anchorOrigin={{
                                        vertical: 'center',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'center',
                                        horizontal: 'left',
                                    }}
                                    onClose={() => {
                                        setShowMilestoneOptionMenu(null);
                                        setMilestoneOptionMenuAnchor(null)
                                    }}
                                >
                                    <div style={{display: "flex", flexDirection: "column", paddingLeft: "10px", paddingTop: "12px", width: "29px", marginTop: "2px"}}>
                                        <div>
                                            <Tooltip title={"Move to top"}>
                                                <IconButton className={css_pages.DropdownButton} disabled={i === 0} onClick={() => {
                                                    setShowMilestoneOptionMenu(null);
                                                    setMilestoneOptionMenuAnchor(null);
                                                    handleMilestoneMoveToTop(milestones[i].USID)
                                                }}>
                                                    <VerticalAlignTop sx={{width: "20px", height: "20px", color: i === 0 ? "#D8DDE4" : "#7B8291"}}/>
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                        <div>
                                            <Tooltip title={"Move up"}>
                                                <IconButton className={css_pages.DropdownButton} disabled={i === 0} onClick={() => {
                                                    setShowMilestoneOptionMenu(null);
                                                    setMilestoneOptionMenuAnchor(null);
                                                    handleMilestoneMoveUp(milestones[i].USID)
                                                }}>
                                                    <North sx={{width: "20px", height: "20px", color: i === 0 ? "#D8DDE4" : "#7B8291"}}/>
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                        <div>
                                            <Tooltip title={"Relocate"}>
                                                <IconButton className={css_pages.DropdownButton} onClick={() => {
                                                    setShowMilestoneOptionMenu(null);
                                                    setMilestoneOptionMenuAnchor(null);
                                                    setShowMilestoneRelocate(milestones[i])
                                                }}>
                                                    <SwapVerticalCircle sx={{width: "20px", height: "20px", color: "#7B8291"}}/>
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                        <div>
                                            <Tooltip title={"Move down"}>
                                                <IconButton className={css_pages.DropdownButton} disabled={i === milestones.length - 1} onClick={() => {
                                                    setShowMilestoneOptionMenu(null);
                                                    setMilestoneOptionMenuAnchor(null);
                                                    handleMilestoneMoveDown(milestones[i].USID)
                                                }}>
                                                    <South sx={{width: "20px", height: "20px", color: i === milestones.length - 1 ? "#D8DDE4" : "#7B8291"}}/>
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                        <div>
                                            <Tooltip title={"Move to bottom"}>
                                                <IconButton className={css_pages.DropdownButton} disabled={i === milestones.length - 1} onClick={() => {
                                                    setShowMilestoneOptionMenu(null);
                                                    setMilestoneOptionMenuAnchor(null)
                                                    handleMilestoneMoveToBottom(milestones[i].USID)
                                                }}>
                                                    <VerticalAlignBottom sx={{width: "20px", height: "20px", color: i === milestones.length - 1 ? "#D8DDE4" : "#7B8291"}}/>
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </Popover>
                            </div>
                        </div>
                    </div>
                    {renderProjectPhaseMilestoneRow(milestones[i])}
                </div>
            )
        }
        content.push(
            <div key={"N"} style={{display: "flex", flexDirection: "row", width: "100%", height: "50px", backgroundColor: "#FFFFFF", borderTop: "1px solid #D8DDE4", overflow: "clip"}}>
                <div style={{display: "flex", flexDirection: "row", minWidth: "612px", borderRight: "1px solid #D8DDE4", backgroundColor: "#FFFFFF"}}>
                    <div style={{width: "5px", backgroundColor: "#D8DDE4"}}>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", width: "230px", marginLeft: "24px", overflow: "clip"}}>
                        <Button className={css_buttons.whiteStandardButton} style={{cursor: "pointer", height: "35px", padding: "0 15px 0 5px"}} size="small" disabled={!hasPrivilege("ADD_MILESTONE", inboundProjectPlanUSID!) || phase.Status === "DONE"}
                            onClick={() => {
                                // @ts-ignore
                                MemoryContext.components["ProjectPlanDetail-EO-ProjectPlanUSID"] = inboundProjectPlanUSID;
                                // @ts-ignore
                                MemoryContext.components["ProjectPlanDetail-EO-PhaseUSID"] = phase.USID;
                                setShowAddPhaseMilestone(true);
                            }}
                            startIcon={<Add sx={{margin: "14px 0 0 0", width: "20px", height: "20px"}}/>}>
                            <Typography style={{margin: "16px 0 0 6px", fontSize: "13px", fontWeight: 500}}>Add milestone</Typography>
                        </Button>
                        {!hasPrivilege("ADD_MILESTONE", inboundProjectPlanUSID!) || phase.Status === "DONE"? (
                            <div style={{marginTop: "13px"}}>
                                <Tooltip title={!hasPrivilege("ADD_MILESTONE", inboundProjectPlanUSID!) ? "This feature is disabled because you do not have the 'ADD_MILESTONE' privilege." : "This feature is disabled because the status of the phase is 'DONE'"}>
                                    <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                </Tooltip>
                            </div>
                        ) : null}
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", width: "1170px", minWidth: "1170px", maxWidth: "1170px", backgroundColor: "#FFFFFF"}}/>
            </div>
        )
        return (
            content
        )
    }

    function renderYearHeader() {
        let reference = referenceTimestamp;
        let counter = moment(`${reference.format("YYYY")}-01-01`, 'YYYY-MM-DD')
        let current = moment();

        let rows = [];
        for (let i = 0; i < 12; i++) {
            rows.push(
                <div key={i + 'month'} style={{height: "30px", display: "flex", flexDirection: "row", justifyContent: "center", width: yearCellWidth, backgroundColor: (counter.format("MMM") === current.format("MMM") && counter.format("YYYY") === current.format("YYYY")) ? "#021EBB" : "transparent", borderRadius: "4px"}}>
                    <Typography style={{paddingTop: "4px", fontSize: "13px",
                        fontWeight: (counter.format("MMM") === current.format("MMM") && counter.format("YYYY") === current.format("YYYY")) ? 500 : 400,
                        color: (counter.format("MMM") === current.format("MMM") && counter.format("YYYY") === current.format("YYYY")) ? "#FFFFFF" : "#000000"
                    }}>{counter.format("MMM").toUpperCase()}</Typography>
                </div>
            )
            counter = counter.add(1, 'month');
        }
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", alignContent: "flex-start", height: "35px", width: "615px"}}>
                    <Tooltip title={"Previous Year"}>
                        <Button variant="outlined" className={css_buttons.blueOutlinedButton} style={{margin: "10px 5px 5px 20px", padding: "0 0 0 0", height: "25px", width: "25px"}}
                                onClick={() => {
                                    setReferenceTimestamp(referenceTimestamp.clone().subtract(1, "year"))
                                }}>
                            &#60;
                        </Button>
                    </Tooltip>
                    <Tooltip title={"Next Year"}>
                        <Button variant="outlined" className={css_buttons.blueOutlinedButton} style={{margin: "10px 15px 5px 5px", padding: "0 0 0 0", height: "25px", width: "25px"}}
                                onClick={() => {
                                    setReferenceTimestamp(referenceTimestamp.clone().add(1, "year"))
                                }}>
                            &#62;
                        </Button>
                    </Tooltip>
                    <Typography style={{margin: "8px 0 0 0", fontSize: "18px", fontWeight: 400, color: "#000000"}}>{reference.format("YYYY")}</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "row", paddingTop: "13px"}}>
                    {rows}
                </div>
            </>
        )
    }

    function renderQuarterHeader() {
        let reference = referenceTimestamp;
        let counter = moment(reference)

        return (
            <>
                <div style={{display: "flex", flexDirection: "row", alignContent: "flex-start", height: "35px", width: "615px"}}>
                    <Tooltip title={"Previous Quarter"}>
                        <Button variant="outlined" className={css_buttons.blueOutlinedButton} style={{margin: "10px 5px 5px 20px", padding: "0 0 0 0", height: "25px", width: "25px"}}
                                onClick={() => {
                                }}>
                            &#60;
                        </Button>
                    </Tooltip>
                    <Tooltip title={"Next Quarter"}>
                        <Button variant="outlined" className={css_buttons.blueOutlinedButton} style={{margin: "10px 15px 5px 5px", padding: "0 0 0 0", height: "25px", width: "25px"}}
                                onClick={() => {
                                }}>
                            &#62;
                        </Button>
                    </Tooltip>
                    <Typography style={{margin: "8px 0 0 0", fontSize: "18px", fontWeight: 400, color: "#000000"}}></Typography>
                </div>
                <div style={{display: "flex", flexDirection: "row", paddingTop: "13px"}}>
                    <div style={{height: "30px", display: "flex", flexDirection: "row", justifyContent: "center", width: "292px", backgroundColor: counter.quarter() === reference.quarter() ? "#021EBB" : "transparent", borderRadius: "4px"}}>
                        <Typography style={{paddingTop: "4px", fontSize: "13px", fontWeight: counter.quarter() === reference.quarter() ? 500 : 400, color: counter.quarter() === reference.quarter() ? "#FFFFFF" : "#000000"}}>Q{counter.quarter()}</Typography>
                    </div>
                    <div style={{height: "30px", display: "flex", flexDirection: "row", justifyContent: "center", width: "292px", backgroundColor: counter.add(1, 'quarter').quarter() === reference.quarter() ? "#021EBB" : "transparent", borderRadius: "4px"}}>
                        <Typography style={{paddingTop: "4px", fontSize: "13px", fontWeight: counter.quarter() === reference.quarter() ? 500 : 400, color: counter.quarter() === reference.quarter() ? "#FFFFFF" : "#000000"}}>Q{counter.quarter()}</Typography>
                    </div>
                    <div style={{height: "30px", display: "flex", flexDirection: "row", justifyContent: "center", width: "292px", backgroundColor: counter.add(1, 'quarter').quarter() === reference.quarter() ? "#021EBB" : "transparent", borderRadius: "4px"}}>
                        <Typography style={{paddingTop: "4px", fontSize: "13px", fontWeight: counter.quarter() === reference.quarter() ? 500 : 400, color: counter.quarter() === reference.quarter() ? "#FFFFFF" : "#000000"}}>Q{counter.quarter()}</Typography>
                    </div>
                    <div style={{height: "30px", display: "flex", flexDirection: "row", justifyContent: "center", width: "292px", backgroundColor: counter.add(1, 'quarter').quarter() === reference.quarter() ? "#021EBB" : "transparent", borderRadius: "4px"}}>
                        <Typography style={{paddingTop: "4px", fontSize: "13px", fontWeight: counter.quarter() === reference.quarter() ? 500 : 400, color: counter.quarter() === reference.quarter() ? "#FFFFFF" : "#000000"}}>Q{counter.quarter()}</Typography>
                    </div>
                </div>
            </>
        )
    }

    function renderMonthHeader() {
        let reference = referenceTimestamp;
        let counter = moment(`${reference.format("YYYY")}-${reference.format("MM")}-01`, 'YYYY-MM-DD')
        let current = moment();

        let monthHeaderCellWidth = "40px";
        let daysInMonth = reference.daysInMonth();

        if (daysInMonth === 28) {
            monthHeaderCellWidth = "41px"
        }
        if (daysInMonth === 29) {
            monthHeaderCellWidth = "41px"
        }
        if (daysInMonth === 30) {
            monthHeaderCellWidth = "41px"
        }
        if (daysInMonth === 31) {
            monthHeaderCellWidth = "40px"
        }
        let rows = [];
        for (let i = 0; i < daysInMonth; i++) {
            rows.push(
                <div key={i + 'day'} style={{height: "30px", display: "flex", flexDirection: "row", justifyContent: "center", width: monthHeaderCellWidth, backgroundColor: (counter.format("YYYY") === current.format("YYYY") && counter.format("MMM") === current.format("MMM") && counter.date() === current.date()) ? "#021EBB" : "transparent", borderRight: "1px solid #EDEFF3", borderRadius: "4px"}}>
                    <Typography style={{padding: "6px 0 0 0", fontSize: "12px", fontWeight: (i+1) === reference.date() ? 500 : 400, color: (counter.format("YYYY") === current.format("YYYY") && counter.format("MMM") === current.format("MMM") && counter.date() === current.date()) ? "#FFFFFF" : "#000000"}}>{i + 1}</Typography>
                </div>
            )
            counter = counter.add(1, "days")
        }
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", alignContent: "flex-start", height: "35px", width: "615px"}}>
                    <Tooltip title={"Previous Month"}>
                        <Button variant="outlined" className={css_buttons.blueOutlinedButton} style={{margin: "10px 5px 5px 20px", padding: "0 0 0 0", height: "25px", width: "25px"}}
                                onClick={() => {
                                    setReferenceTimestamp(referenceTimestamp.clone().subtract(1, "month"))
                                }}>
                            &#60;
                        </Button>
                    </Tooltip>
                    <Tooltip title={"Next Month"}>
                        <Button variant="outlined" className={css_buttons.blueOutlinedButton} style={{margin: "10px 15px 5px 5px", padding: "0 0 0 0", height: "25px", width: "25px"}}
                                onClick={() => {
                                    setReferenceTimestamp(referenceTimestamp.clone().add(1, "month"))
                                }}>
                            &#62;
                        </Button>
                    </Tooltip>
                    <Typography style={{margin: "8px 0 0 0", fontSize: "18px", fontWeight: 400, color: "#000000"}}>{reference.format("MMMM")}&nbsp;{reference.format("YYYY")}</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "row", width: "1170px", minWidth: "1170px", maxWidth: "1170px", marginTop: "13px", height: "35px"}}>
                    {rows}
                </div>
            </>
        )
    }

    function renderWeekHeader() {
        let reference = referenceTimestamp;
        var counter = reference.clone().weekday(1);
        let current = moment();

        let monthHeaderCellWidth = "167px";

        let rows = [];
        for (let i = 0; i < 7; i++) {
            rows.push(
                <div key={i + 'week'} style={{display: "flex", flexDirection: "column", justifyContent: "center", width: monthHeaderCellWidth, backgroundColor: (counter.format("YYYY") === current.format("YYYY") && counter.format("MMM") === current.format("MMM") && counter.date() === current.date()) ? "#021EBB" : "transparent", borderRadius: "4px"}}>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
                        <Typography style={{padding: "0px 0 0 0", fontSize: "12px", fontWeight: (counter.format("YYYY") === current.format("YYYY") && counter.format("MMM") === current.format("MMM") && counter.date() === current.date()) ? 500 : 400, color: (counter.format("YYYY") === current.format("YYYY") && counter.format("MMM") === current.format("MMM") && counter.date() === current.date()) ? "#FFFFFF" : "#000000"}}>{counter.format("ddd").toUpperCase()}</Typography>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
                        <Typography style={{padding: "0px 0 0 0", fontSize: "12px", fontWeight: (counter.format("YYYY") === current.format("YYYY") && counter.format("MMM") === current.format("MMM") && counter.date() === current.date()) ? 500 : 400, color: (counter.format("YYYY") === current.format("YYYY") && counter.format("MMM") === current.format("MMM") && counter.date() === current.date()) ? "#FFFFFF" : "#000000"}}>{counter.date()}</Typography>
                    </div>
                </div>
            )
            counter.add(1,'days')
        }
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", alignContent: "flex-start", height: "35px", width: "615px"}}>
                    <Tooltip title={"Previous Month"}>
                        <Button variant="outlined" className={css_buttons.blueOutlinedButton} style={{margin: "10px 5px 5px 20px", padding: "0 0 0 0", height: "25px", width: "25px"}}
                                onClick={() => {
                                    setReferenceTimestamp(referenceTimestamp.clone().subtract(1, "week"))
                                }}>
                            &#60;
                        </Button>
                    </Tooltip>
                    <Tooltip title={"Next Month"}>
                        <Button variant="outlined" className={css_buttons.blueOutlinedButton} style={{margin: "10px 15px 5px 5px", padding: "0 0 0 0", height: "25px", width: "25px"}}
                                onClick={() => {
                                    setReferenceTimestamp(referenceTimestamp.clone().add(1, "week"))
                                }}>
                            &#62;
                        </Button>
                    </Tooltip>
                    <Typography style={{margin: "8px 0 0 0", fontSize: "18px", fontWeight: 400, color: "#000000"}}>{reference.format("MMMM")}&nbsp;{reference.clone().weekday(1).date()},&nbsp;{reference.format("YYYY")} - {reference.clone().weekday(7).format("MMMM")}&nbsp;{reference.clone().weekday(7).date()},&nbsp;{reference.format("YYYY")}</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "row", width: "1170px", minWidth: "1170px", maxWidth: "1170px", marginTop: "9px", height: "35px"}}>
                    {rows}
                </div>
            </>
        )
    }

    function disassociateSecondaryPosition(USID: string) {
        adminPositionMembershipEnterpriseComponent.firstRecord();
        while(true) {
            if (adminPositionMembershipEnterpriseComponent.getAttributeValue("USID") === USID) {
                break;
            }
            adminPositionMembershipEnterpriseComponent.nextRecord();
        }
        setAdminPositionMembershipDeleteUSID(USID)
        adminPositionMembershipEnterpriseComponent.executeDelete()
    }

    function disassociateSecondaryUserGroup(USID: string) {
        adminUserGroupMembershipEnterpriseComponent.firstRecord();
        while(true) {
            if (adminUserGroupMembershipEnterpriseComponent.getAttributeValue("USID") === USID) {
                break;
            }
            adminUserGroupMembershipEnterpriseComponent.nextRecord();
        }
        setAdminUserGroupMembershipDeleteUSID(USID)
        adminUserGroupMembershipEnterpriseComponent.executeDelete()
    }

    function disassociateSecondaryWorkGroup(workGroupUSID: string) {
        console.log(workGroupUSID)
    }

    function addSecondaryPosition() {
        sessionContext.setGeneralPurposeVariable(projectPlanUSID!);
        setShowAddSecondaryPosition(true)
    }

    function addSecondaryUserGroup() {
        sessionContext.setGeneralPurposeVariable(projectPlanUSID!);
        setShowAddSecondaryUserGroup(true)
    }

    function addSecondaryWorkGroup() {
    }

    function executeQuickFilter() {
        const projectPlanEnterpriseComponent: EnterpriseComponent = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!

        let qbe = {
            "ShifamedMessage": {
                "-idoc": "v1.ProjectPlan-001",
                "-id": uuidv4(),
                "ProjectPlan": {
                    '_attributes': {
                        'limit': 1,
                        'sort': null,
                        'offset': 0
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "primary",
                                "Operator": "AND",
                                "Type": "QueryGroup",
                                "Membership": {
                                    "Member": [
                                        {
                                            "Type": "Attribute",
                                            "Name": "USID",
                                            "Value": projectPlanEnterpriseComponent.getAttributeValue("USID"),
                                            "Operator": "EQUAL"
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                }
            }
        }
        if (controls["QuickFilter"].value !== "") {
            // @ts-ignore
            qbe.ShifamedMessage.ProjectPlan["ProjectPlanPhase"] = {
                '_attributes': {
                    'limit': 10000,
                    'sort': null,
                    'offset': 0
                },
                "QueryGroups": {
                    "QueryGroup": [
                        {
                            "Name": "primary",
                            "Operator": "AND",
                            "Type": "QueryGroup",
                            "Membership": {
                                "Member": [{
                                    "Type": "Attribute",
                                    "Name": "Name",
                                    "Value": controls["QuickFilter"].value,
                                    "Operator": projectPlanEnterpriseComponent.translate_operator(quickFilterMenuOption!)
                                }]
                            }
                        }
                    ]
                }
            }
        }
        projectPlanEnterpriseComponent.newQuery()
        projectPlanEnterpriseComponent.setQBE(qbe)
        projectPlanEnterpriseComponent.executeQuery(1, 100000)
    }

    function quickFilterInputChangedHandler(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const updatedFormElement = updateObject(controls["QuickFilter"], {
            value: event.target.value,
            touched: true,
            valid: true,
            helperText: null,
            invitationInProgress: false,
            userExistsInClinic: false,
            userExistsInProvider: false,
            userDoesNotExist: null,
            mainEmailVerifiedState: null,
            invitationSaved: false,
        });
        const updatedForm = updateObject(controls, {
            "QuickFilter": updatedFormElement,
        });

        setControls(updatedForm);
    }

    let status;
    let backgroundColor;

    if (projectPlanBuffer.get("Status") === "DRAFT") {
        status = "DRAFT";
        backgroundColor = Blue3;
    } else {
        status = "RELEASED";
        backgroundColor = Green4
    }

    let yearCellWidth = "120px";
    let planningView = (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#FFFFFF", marginTop: "10px"}}>
                <div style={{display: "flex", flexDirection: "row", paddingTop: "9px"}}>
                    <div style={{display: "flex", flexDirection: "row", width: "40px"}}>
                        <IconButton className={css_buttons.verticalButton} style={{height: "40px"}} onClick={(event) => {
                                setShowProjectPlanDisplayOptionsMenu(true)
                                setShowProjectPlanDisplayOptionsAnchor(event.currentTarget)
                            }}>
                            <MoreVert sx={{marginTop: "-5px", marginLeft: "0px", width: "35px", height: "35px", color: "#7B8291"}}/>
                        </IconButton>
                        <Popover
                            open={showProjectPlanDisplayOptionsMenu}
                            anchorEl={showProjectPlanDisplayOptionsAnchor}
                            id={"menu"}
                            anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                            }}
                            onClose={() => {
                                setShowProjectPlanDisplayOptionsMenu(false)
                                setShowProjectPlanDisplayOptionsAnchor(null)
                            }}
                        >
                            <div style={{display: "flex", flexDirection: "column", paddingLeft: "10px", paddingTop: "10px", width: "29px"}}>
                                <div>
                                    <Tooltip title={"Move to top"}>
                                        <IconButton className={css_pages.DropdownButton} onClick={() => {
                                            setShowPhaseOptionMenu(null);
                                            setPhaseOptionMenuAnchor(null)
                                        }}>
                                            <VerticalAlignTop sx={{width: "20px", height: "20px", color: "#7B8291"}}/>
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                <div>
                                    <Tooltip title={"Move up"}>
                                        <IconButton className={css_pages.DropdownButton} onClick={() => {
                                            setShowPhaseOptionMenu(null);
                                            setPhaseOptionMenuAnchor(null)
                                        }}>
                                            <North sx={{width: "20px", height: "20px", color: "#7B8291"}}/>
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                <div>
                                    <Tooltip title={"Move down"}>
                                        <IconButton className={css_pages.DropdownButton} onClick={() => {
                                            setShowPhaseOptionMenu(null);
                                            setPhaseOptionMenuAnchor(null)
                                        }}>
                                            <South sx={{width: "20px", height: "20px", color: "#7B8291"}}/>
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                <div>
                                    <Tooltip title={"Move to bottom"}>
                                        <IconButton className={css_pages.DropdownButton} onClick={() => {
                                            setShowPhaseOptionMenu(null);
                                            setPhaseOptionMenuAnchor(null)
                                        }}>
                                            <VerticalAlignBottom sx={{width: "20px", height: "20px", color: "#7B8291"}}/>
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            </div>
                        </Popover>
                    </div>
                    <Button
                        className={css_buttons.blueStandardButton} style={{cursor: "pointer", height: "35px", padding: "0 15px 0 15px"}} size="small" disabled={projectPlanFetchBackgroundOperation || !hasPrivilege("ADD_PHASE", inboundProjectPlanUSID!)}
                        onClick={() => {
                            // @ts-ignore
                            MemoryContext.components["ProjectPlanDetail-EO-ProjectPlanUSID"] = inboundProjectPlanUSID;
                            setShowAddPhase(true);
                        }}
                        startIcon={<AddCircle sx={{color: "#FFFFFF", width: "30px", height: "30px"}}/>}>
                        Add Phase
                    </Button>
                    {!hasPrivilege("ADD_PHASE", inboundProjectPlanUSID!) ? (
                        <div style={{marginLeft: "2px", marginTop: "5px"}}>
                            <Tooltip title={"This feature is disabled because you do not have the 'ADD_PHASE' privilege."}>
                                <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                            </Tooltip>
                        </div>
                    ) : null}
                    <div style={{marginLeft: "20px"}}>
                        <Button
                            className={css_buttons.blueStandardButton} style={{cursor: "pointer", height: "35px", padding: "0 15px 0 15px"}} size="small" disabled={projectPlanFetchBackgroundOperation || !hasPrivilege("DELETE_PLAN", inboundProjectPlanUSID!)}
                            onClick={(e) => {
                                setShowFilterMenu(e.currentTarget);
                            }}
                            startIcon={<FilterList sx={{color: "#FFFFFF", width: "25px", height: "25px"}}/>}>
                            Filter
                        </Button>
                        {showFilterMenu ? (
                            <Menu anchorEl={showFilterMenu}
                                  anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                  transformOrigin={{vertical: -5, horizontal: "right"}}
                                  open={true}
                                  onClose={() => setShowFilterMenu(null)}
                                  TransitionProps={{
                                      onExited: () => setQuickFilterMenu(null),
                                  }}>
                                <MenuItem key={"filterMenu_myMilestones"} style={{height: "45px"}} onClick={() => {
                                    let newShowMyMilestones = !showMyMilestones;
                                    setShowMyMilestones(newShowMyMilestones);
                                    setShowMilestonesByAssignee(false);
                                    setShowFilterMenu(null);
                                    if (newShowMyMilestones) {
                                        setActiveFilter({"Title": "My Milestones", "Subtitle": sessionContext.getName()})
                                    } else {
                                        setActiveFilter(null)
                                    }
                                }}>
                                    {showMyMilestones ? <Check style={{marginRight: "15px"}}/> : <div style={{width: "43px"}}/>}
                                    <div style={{display: "block"}}>
                                        <div>
                                             <Typography style={{ fontSize: "15px", fontWeight: 400, color: Grey17}}>My Milestones</Typography>
                                        </div>
                                        <div style={{marginTop: "-5px"}}>
                                            <Typography style={{fontSize: "12px", fontWeight: 400, color: Grey7}}>Show all milestones which you are an assignee</Typography>
                                        </div>
                                    </div>
                                </MenuItem>
                                <MenuItem key={"filterMenu_milestonesByAssignee"} style={{height: "45px"}} onClick={() => {
                                    let newShowMilestonesByAssignee = !showMilestonesByAssignee;
                                    setCurrentAssigneeFilterUSID(undefined);
                                    setShowMilestonesByAssignee(newShowMilestonesByAssignee);
                                    setShowMilestonesByAssigneeDialog(newShowMilestonesByAssignee);
                                    setShowMyMilestones(false);
                                    setShowFilterMenu(null);
                                    if (newShowMilestonesByAssignee) {
                                        setActiveFilter({"Title": "Milestones by Assignee", "Subtitle": ""})
                                    } else {
                                        setActiveFilter(null);
                                    }
                                    setShowMilestonesByAssigneeUSID(null);
                                }}>
                                    {showMilestonesByAssignee ? <Check style={{marginRight: "15px"}}/> : <div style={{width: "43px"}}/>}
                                    <div style={{display: "block"}}>
                                        <div>
                                             <Typography style={{ fontSize: "15px", fontWeight: 400, color: Grey17}}>Milestones by Assignee</Typography>
                                        </div>
                                        <div style={{marginTop: "-5px"}}>
                                            <Typography style={{fontSize: "12px", fontWeight: 400, color: Grey7}}>Show all milestones for a selected assignee</Typography>
                                        </div>
                                    </div>
                                </MenuItem>
                            </Menu>
                        ) : null}
                    </div>
                    <div style={{display: "flex", flexDirection: "column", marginLeft: "10px"}}>
                        <div>
                            <Typography style={{fontSize: "12px", fontWeight: 400, color: Grey17}}>{activeFilter?.Title}</Typography>
                        </div>
                        <div>
                            <Typography style={{fontSize: "12px", fontWeight: 400, color: Grey5}}>{activeFilter?.Subtitle}</Typography>
                        </div>
                    </div>
                </div>
                <div>
                    {projectPlanFetchBackgroundOperation ? (
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: "10px"}}>
                            <div style={{margin: "-3px 0 0 0"}}>
                                <img width="35" height="35" src={spinner} alt="spinner" />
                            </div>
                            <div className={css_enlil_table.BlinkingText} style={{margin: "4px 0 0 5px"}}>
                                 <Typography style={{fontSize: "14px", fontWeight: 400, color: Grey4}}>Loading...</Typography>
                            </div>
                        </div>
                    ) : null}
                </div>
                <div style={{display: "flex", flexDirection: "row", paddingTop: "8px"}}>
                    <div style={{marginLeft: "10px"}}>
                        <Button className={timePerspective === "Week" ? css_buttons.calendarButtonSelected : css_buttons.calendarButton} disabled={projectPlanFetchBackgroundOperation} onClick={() => {
                            setTimePerspective("Week");
                        }}>Week
                        </Button>
                    </div>
                    <div style={{marginLeft: "10px"}}>
                        <Button className={timePerspective === "Month" ? css_buttons.calendarButtonSelected : css_buttons.calendarButton} disabled={projectPlanFetchBackgroundOperation} onClick={() => {
                            setTimePerspective("Month");
                        }}>Month
                        </Button>
                    </div>
                    <div style={{marginLeft: "10px"}}>
                        <Button className={timePerspective === "Quarter" ? css_buttons.calendarButtonSelected : css_buttons.calendarButton} disabled={projectPlanFetchBackgroundOperation} onClick={() => {
                            setTimePerspective("Quarter");
                        }}>Quarter
                        </Button>
                    </div>
                    <div style={{marginLeft: "10px"}}>
                        <Button className={timePerspective === "Year" ? css_buttons.calendarButtonSelected : css_buttons.calendarButton} disabled={projectPlanFetchBackgroundOperation} onClick={() => {
                            setTimePerspective("Year");
                        }}>Year
                        </Button>
                    </div>
                </div>
            </div>
            <div style={{display: "flex", flexDirection: "column", flexGrow: 1, border: "1px solid #D8DDE4", borderRadius: "5px", overflow: "clip"}}>
                <div style={{display: "flex", flexDirection: "row", width: "100%", height: "80px", backgroundColor: "#EDEFF3"}}>
                    <div style={{display: "flex", flexDirection: "row", minWidth: showAlphabetFilter ? "637px" : "612px", height: "80px", borderRight: "1px solid #D8DDE4", backgroundColor: "#FFFFFF"}}>
                        {1!=1 ? (   /* hiding this code */
                            <div style={{marginTop: "55px", padding: "0 0 1px 1px"}}>
                                <Tooltip title={"Quick filter on phase names"}>
                                    <IconButton className={css_buttons.filterIconButton} style={{marginBottom: "2px"}} onClick={() => {
                                        setShowAlphabetFilter(!showAlphabetFilter);
                                    }}>
                                        <FilterList sx={{width: "22px", height: "22px"}}/>
                                    </IconButton>
                                </Tooltip>
                            </div>
                        ) : null}
                        <div style={{display: "flex", flexDirection: "row", width: "100%", backgroundColor: "#FFFFFF"}}>
                            <div style={{marginTop: "10px", padding: "10px 5px 1px 13px", display: "flex", flexDirection: "row", width: "100%", marginRight: "5px"}}>
                                <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
                                    <TextField
                                        onKeyUp={executeQuickFilter}
                                        fullWidth={true}
                                        size="small"
                                        id={"QuickFilterField"}
                                        onChange={(event) => quickFilterInputChangedHandler(event)}
                                        value={controls["QuickFilter"].value}
                                        variant="outlined"
                                        slotProps={{
                                            inputLabel: {shrink: true},
                                        }}
                                    />
                                    <Typography style={{fontSize: "12px", fontWeight: 400, color: Grey4}}>{quickFilterMenuOption}</Typography>
                                </div>
                                <div style={{width: "40px", height: "40px", marginLeft: "5px", marginTop: "0px", backgroundColor: "#FFFFFF"}}>
                                    <IconButton className={css_buttons.filterIconButton} onClick={(e) => {
                                        setQuickFilterMenu(e.currentTarget)
                                    }}>
                                        <FilterAltOutlined />
                                    </IconButton>
                                    {quickFilterMenu !== null ? (
                                        <Menu anchorEl={quickFilterMenu}
                                              anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                              transformOrigin={{vertical: -5, horizontal: "right"}}
                                              open={true}
                                              onClose={() => setQuickFilterMenu(null)}
                                              TransitionProps={{
                                                  onExited: () => setQuickFilterMenu(null),
                                              }}>
                                            <MenuItem key={"quickFilterMenu" + "_contains"} style={{height: "35px"}} onClick={() => {setQuickFilterMenuOption("Contains"); setQuickFilterMenu(null);}}>
                                                <ListItemIcon>
                                                    {quickFilterMenuOption === "Contains" ? <Check /> : null}
                                                </ListItemIcon>
                                                <ListItemText primary="Contains"/>
                                            </MenuItem>
                                            <MenuItem key={quickFilterMenu + "_does_not_contain"} style={{height: "35px"}} onClick={() => {setQuickFilterMenuOption("Does not contain"); setQuickFilterMenu(null);}}>
                                                <ListItemIcon>
                                                    {quickFilterMenuOption === "Does not contain" ? <Check /> : null}
                                                </ListItemIcon>
                                                <ListItemText primary="Does not contain"/>
                                            </MenuItem>
                                            <MenuItem key={quickFilterMenu + "_is_equal_to"} style={{height: "35px"}} onClick={() => {setQuickFilterMenuOption("Is equal to"); setQuickFilterMenu(null);}}>
                                                <ListItemIcon>
                                                    {quickFilterMenuOption === "Is equal to" ? <Check /> : null}
                                                </ListItemIcon>
                                                <ListItemText primary="Is equal to"/>
                                            </MenuItem>
                                            <MenuItem key={quickFilterMenu + "_is_not_equal_to"} style={{height: "35px"}} onClick={() => {setQuickFilterMenuOption("Is not equal to"); setQuickFilterMenu(null);}}>
                                                <ListItemIcon>
                                                    {quickFilterMenuOption === "Is not equal to" ? <Check /> : null}
                                                </ListItemIcon>
                                                <ListItemText primary="Is not equal to"/>
                                            </MenuItem>
                                            <MenuItem key={quickFilterMenu + "_starts_with"} style={{height: "35px"}} onClick={() => {setQuickFilterMenuOption("Starts with"); setQuickFilterMenu(null);}}>
                                                <ListItemIcon>
                                                    {quickFilterMenuOption === "Starts with" ? <Check /> : null}
                                                </ListItemIcon>
                                                <ListItemText primary="Starts with"/>
                                            </MenuItem>
                                            <MenuItem key={quickFilterMenu + "_ends_with"} style={{height: "35px"}} onClick={() => {setQuickFilterMenuOption("Ends with"); setQuickFilterMenu(null);}}>
                                                <ListItemIcon>
                                                    {quickFilterMenuOption === "Ends with" ? <Check /> : null}
                                                </ListItemIcon>
                                                <ListItemText primary="Ends with"/>
                                            </MenuItem>
                                            <MenuItem key={quickFilterMenu + "_is_null"} style={{height: "35px"}} onClick={() => {setQuickFilterMenuOption("Is null"); setQuickFilterMenu(null);}}>
                                                <ListItemIcon>
                                                    {quickFilterMenuOption === "Is null" ? <Check /> : null}
                                                </ListItemIcon>
                                                <ListItemText primary="Is null"/>
                                            </MenuItem>
                                            <MenuItem key={quickFilterMenu + "_is_not_null"} style={{height: "35px"}} onClick={() => {setQuickFilterMenuOption("Is not null"); setQuickFilterMenu(null);}}>
                                                <ListItemIcon>
                                                    {quickFilterMenuOption === "Is not null" ? <Check /> : null}
                                                </ListItemIcon>
                                                <ListItemText primary="Is not null"/>
                                            </MenuItem>
                                            <MenuItem key={quickFilterMenu + "_is_empty"} style={{height: "35px"}} onClick={() => {setQuickFilterMenuOption("Is empty"); setQuickFilterMenu(null);}}>
                                                <ListItemIcon>
                                                    {quickFilterMenuOption === "Is empty" ? <Check /> : null}
                                                </ListItemIcon>
                                                <ListItemText primary="Is empty"/>
                                            </MenuItem>
                                            <MenuItem key={quickFilterMenu + "_is_not_empty"} style={{height: "35px"}} onClick={() => {setQuickFilterMenuOption("Is not empty"); setQuickFilterMenu(null);}}>
                                                <ListItemIcon>
                                                    {quickFilterMenuOption === "Is not empty" ? <Check /> : null}
                                                </ListItemIcon>
                                                <ListItemText primary="Is not empty"/>
                                           </MenuItem>
                                        </Menu>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", width: "1170px", minWidth: "1170px", maxWidth: "1170px", height: "80px"}}>
                        {timePerspective === "Year" ? (renderYearHeader()) : null}
                        {timePerspective === "Quarter" ? (renderQuarterHeader()) : null}
                        {timePerspective === "Month" ? (renderMonthHeader()) : null}
                        {timePerspective === "Week" ? (renderWeekHeader()) : null}
                    </div>
                </div>
                {renderProjectPhases()}
            </div>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", backgroundColor: "#FFFFFF", marginTop: "40px"}}>
                <FontAwesomeIcon icon={faDiamond} style={{color: "#00A044", width: "22px", height: "22px"}}/>
                <Typography style={{fontSize: "14px", fontWeight: 400, color: "#000000", marginLeft: "10px"}}>Milestone Status = DONE</Typography>
            </div>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", backgroundColor: "#FFFFFF", marginTop: "10px"}}>
                <FontAwesomeIcon icon={faDiamond} style={{color: "#B26000", width: "22px", height: "22px"}}/>
                <Typography style={{fontSize: "14px", fontWeight: 400, color: "#000000", marginLeft: "10px"}}>Milestone Status = IN PROGRESS and Due Date is set</Typography>
            </div>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", backgroundColor: "#FFFFFF", marginTop: "10px"}}>
                <FontAwesomeIcon icon={faDiamondRegular} style={{color: "#B26000", width: "22px", height: "22px"}}/>
                <Typography style={{fontSize: "14px", fontWeight: 400, color: "#000000", marginLeft: "10px", marginTop: "1px"}}>Milestone Due Date is set, No references added</Typography>
            </div>

            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", backgroundColor: "#FFFFFF", marginTop: "20px"}}>
                <Circle sx={{color: "#00A044"}}/>
                <Typography style={{fontSize: "14px", fontWeight: 400, color: "#000000", marginLeft: "10px"}}>Phase Status = DONE</Typography>
            </div>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", backgroundColor: "#FFFFFF", marginTop: "10px"}}>
                <Circle sx={{color: "#B26000"}}/>
                <Typography style={{fontSize: "14px", fontWeight: 400, color: "#000000", marginLeft: "10px"}}>Phase Status = IN PROGRESS and Due Date is set</Typography>
            </div>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", backgroundColor: "#FFFFFF", marginTop: "10px"}}>
                <CircleOutlined sx={{color: "#B26000"}}/>
                <Typography style={{fontSize: "14px", fontWeight: 400, color: "#000000", marginLeft: "10px", marginTop: "1px"}}>Phase Due Date is set, No references added</Typography>
            </div>
        </div>
    );

    function stringAvatar(name: string) {
        return name
            .split(" ")
            .map(word => word[0])
            .join("")
            .substring(0, 2);
    }

    function formatLastEdit() {
        let datetime = projectPlanBuffer.get("GlobalLastModifiedDatetime")

        let now = moment().utc()
        let diffInMinutes = now.diff(datetime, "minutes")
        let diffInHours = now.diff(datetime, "hours")
        let diffInDays = now.diff(datetime, "days")
        let diffInYears = now.diff(datetime, "days")

        let name = projectPlanBuffer.get("GlobalLastModifiedByUserName")
        if (name === undefined) name = ""
        else name = `(${name})`

        if (datetime === undefined) {
            // do nothing
        } else if (diffInMinutes === 0) {
            return `Just now ${name}`
        } else if (diffInMinutes < 60) {
            if (diffInMinutes === 1) {
                return `${diffInMinutes} minute ago ${name}`;
            } else {
                return `${diffInMinutes} minutes ago ${name}`;
            }
        } else if (diffInMinutes > 60 && diffInMinutes < 1440) {
            if (diffInHours === 1) {
                return `${diffInHours} hour ago ${name}`;
            } else {
                return `${diffInHours} hours ago ${name}`;
            }
        } else if (diffInMinutes > 1440 && diffInMinutes < 525949) {
            if (diffInDays === 1) {
                return `${diffInDays} day ago ${name}`;
            } else {
                return `${diffInDays} days ago ${name}`;
            }
        } else if (diffInMinutes > 525949) {
            if (diffInYears === 1) {
                return `${diffInYears} year ago ${name}`;
            } else {
                return `${diffInYears} years ago ${name}`;
            }
        }
        return "";
    }

    let visibilityView = (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "#FFFFFF", marginTop: "30px", borderBottom: "1px solid #D8DDE4"}}>
                <Typography style={{fontSize: 20, fontWeight: 500, color: "#000000"}}>Positions</Typography>
            </div>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", backgroundColor: "#FFFFFF", marginTop: "10px", textOverflow: "ellipsis", overflow: "hidden"}}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                    <Typography style={{fontSize: 14, fontWeight: 500, color: "#000000"}}>Primary Position:&nbsp;&nbsp;</Typography>
                    <Typography style={{fontSize: 14, fontWeight: 400, color: Grey5}}>{projectPlanBuffer.get("PrimaryPositionName")} (Primary Employee: {projectPlanBuffer.get("PrimaryPositionPrimaryUserName")})</Typography>
                    {projectPlanBuffer.get("PrimaryPositionPrimaryEmployeeUSID") === sessionContext.getEmployeeUSID() || hasPrivilege("PROJECT_MILESTONE_ADMINISTRATION") ? (
                        <Tooltip title={"Change Primary Position"}>
                            <IconButton className={css_buttons.blueIconButton} style={{marginLeft: "5px", marginTop: "-6px"}} onClick={() => {
                                let attribute = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")?.getAttribute("PrimaryPositionUSID")
                                attribute?.getPicklist()!.setAllowNoSelection(false);
                                setShowEditPrimaryPosition(true)
                            }}>
                                <Edit sx={{color: Blue3, width: "20px", height: "20px"}}/>
                            </IconButton>
                        </Tooltip>
                    ): (
                        <>
                            <Tooltip title={"Only the Primary Employee the Primary Position can change the Primary Position"}>
                                <IconButton className={css_buttons.blueIconButton} style={{marginLeft: "5px", marginTop: "-6px"}}>
                                    <Edit sx={{color: Grey5, width: "20px", height: "20px"}}/>
                                </IconButton>
                            </Tooltip>
                        </>
                    )}
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", backgroundColor: "#FFFFFF", marginTop: "0px", textOverflow: "ellipsis", overflow: "hidden"}}>
                    <div>
                        {projectPlanBuffer.get("PrimaryPositionUSID") !== null && (projectPlanBuffer.get("PrimaryPositionPrimaryEmployeeUSID") === sessionContext.getEmployeeUSID() || hasPrivilege("PROJECT_MILESTONE_ADMINISTRATION")) ? (
                            <Button
                                    className={css_buttons.blueIconButton} style={{marginLeft: "5px", marginTop: "-5px"}}
                                    onClick={() => {
                                        let attribute = adminPositionMembershipEnterpriseComponent.getAttribute("PositionUSID")
                                        attribute?.getPicklist()!.setAllowNoSelection(false);
                                        addSecondaryPosition()
                                    }}
                                    startIcon={<ControlPoint sx={{color: Blue3, width: "20px", height: "20px"}}/>}>
                                <Typography style={{fontSize: 14, fontWeight: 500, color: "#000000"}}>Add Secondary Position</Typography>
                            </Button>
                        ): (
                            <Button disabled={true}
                                    className={css_buttons.blueIconButton} style={{marginLeft: "5px", marginTop: "-5px"}}
                                    startIcon={<ControlPoint sx={{color: Grey5, width: "20px", height: "20px"}}/>}>
                                <Typography style={{fontSize: 14, fontWeight: 500, color: Grey5}}>Add Secondary Position</Typography>
                            </Button>
                        )}
                    </div>
                </div>
            </div>
            <div style={{display: "flex", flexDirection: "column", backgroundColor: Grey3, border: "1px solid #7B8291", borderBottom: "0px", borderTopLeftRadius: "10px", borderTopRightRadius: "10px", borderBottomLeftRadius: adminPositionMembershipBuffer.length === 0 ? "5px": "0px", borderBottomRightRadius: adminPositionMembershipBuffer.length === 0 ? "5px": "0px", marginTop: "20px"}}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "transparent", borderBottom: "1px solid #7B8291"}}>
                    <div style={{width: "410px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px"}}>Primary Position</Typography></div>
                    <div style={{width: "5px"}}><Typography style={{fontSize: 26, fontWeight: 500, color: Grey6, marginTop: "0px"}}>|</Typography></div>
                    <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px"}}>Position Membership</Typography></div>
                </div>
                {adminPositionBuffer && adminPositionBuffer.length > 0 ? (
                    <div key={adminPositionBuffer[0].get("USID")} style={{display: "flex", flexDirection: "row", justifyContent: "space-between", backgroundColor: "#FFFFFF", borderBottom: "1px solid #EDEFF3"}}>
                        <div style={{display: "flex", flexDirection: "row"}}>
                            <div style={{marginTop: "10px", marginBottom: "10px", width: "410px"}}>
                                <Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px", textOverflow: "ellipsis", overflow: "hidden"}}>{adminPositionBuffer[0].get("Name")}</Typography>
                            </div>
                            <div style={{width: "300px", display: "flex", flexDirection: "column", marginTop: "5px"}}>
                                {adminPositionBuffer[0].get("ListOfEmployee").Employee.length === 0 ? (
                                     <div style={{display: "flex", flexDirection: "row"}}>
                                        <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Grey5, margin: "15px 0 8px 10px"}}>No members</Typography></div>
                                    </div>
                                ): null}
                                {adminPositionBuffer[0].get("ListOfEmployee").Employee.map((employee: any) => (
                                    <div key={employee.USID} style={{display: "flex", flexDirection: "row"}}>
                                        <div style={{fontSize: 14, fontWeight: 500, color: Black, margin: "3px 0 0 10px"}}>
                                            <Avatar sx={{bgcolor: Blue3, width: 25, height: 25, fontSize: "12px"}}>{stringAvatar(employee.UserName)}</Avatar>
                                        </div>
                                        <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "5px 0 8px 10px"}}>{employee.UserName}</Typography></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ) : null}
                {adminPositionMembershipBuffer.length === 0 ? <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "transparent", height: "5px"}}/> : null}
            </div>
            {adminPositionMembershipBuffer.length > 0 ? (
                <div style={{display: "flex", flexDirection: "column", backgroundColor: Grey3, border: "1px solid #7B8291", borderTopLeftRadius: "0px", borderTopRightRadius: "0px", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px", marginTop: "0px"}}>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "transparent", borderBottom: "1px solid #7B8291"}}>
                        <div style={{width: "410px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px"}}>Secondary Positions</Typography></div>
                        <div style={{width: "5px"}}><Typography style={{fontSize: 26, fontWeight: 500, color: Grey6, marginTop: "0px"}}>|</Typography></div>
                        <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px"}}>Position Membership</Typography></div>
                    </div>
                    {adminPositionMembershipBuffer.map(member => (
                        <div key={member.get("PositionUSID")} style={{display: "flex", flexDirection: "row", justifyContent: "space-between", backgroundColor: "#FFFFFF", borderBottom: "1px solid #EDEFF3"}}>
                            <div style={{display: "flex", flexDirection: "row"}}>
                                <div style={{marginTop: "10px", marginBottom: "10px", width: "410px"}}>
                                    <Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px", textOverflow: "ellipsis", overflow: "hidden"}}>{member.get("PositionName")}</Typography>
                                </div>
                                <div style={{width: "300px", display: "flex", flexDirection: "column", marginTop: "5px"}}>
                                    {member.get("Employees").length === 0 ? (
                                         <div style={{display: "flex", flexDirection: "row"}}>
                                            <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Grey5, margin: "15px 0 8px 10px"}}>No members</Typography></div>
                                        </div>
                                    ): null}
                                    {member.get("Employees").map((employee: any) => (
                                        <div key={employee.USID} style={{display: "flex", flexDirection: "row"}}>
                                            <div style={{fontSize: 14, fontWeight: 500, color: Black, margin: "3px 0 0 10px"}}>
                                                <Avatar sx={{bgcolor: Blue3, width: 25, height: 25, fontSize: "12px"}}>{stringAvatar(employee.UserName)}</Avatar>
                                            </div>
                                            <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "5px 0 8px 10px"}}>{employee.UserName}</Typography></div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div style={{width: "150px", display: "flex", flexDirection: "column"}}>
                                {projectPlanBuffer.get("PrimaryPositionPrimaryEmployeeUSID") === sessionContext.getEmployeeUSID() || hasPrivilege("PROJECT_MILESTONE_ADMINISTRATION") ? (
                                    <div style={{margin: "auto"}}>
                                        {member.get("USID") !== adminPositionMembershipDeleteUSID ? (
                                            <Button style={{marginTop: "10px", marginBottom: "10px", width: "100px"}} className={css_buttons.blueStandardButton} onClick={(e: any) => {
                                                disassociateSecondaryPosition(member.get("USID"))
                                            }}>Disassociate
                                            </Button>
                                        ) : (
                                            <>
                                                {member.get("USID") === adminPositionMembershipDeleteUSID ? (
                                                    <img style={{position: "relative"}} width="55" height="55" src={spinner} alt="spinner" />
                                                ) : null}
                                            </>
                                        )}
                                    </div>
                                ) : (
                                    <div style={{margin: "auto"}}>
                                        <Tooltip title={"Only the Primary Employee (" + projectPlanBuffer.get("PrimaryPositionPrimaryUserName") + ") can disassociate a position"}>
                                            <Button className={css_buttons.blueStandardButton} style={{backgroundColor: "#A8A9AF", width: "100px"}}>Disassociate
                                            </Button>
                                        </Tooltip>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "transparent", height: "5px"}}/>
                </div>
            ) : null}


            {/*-- User Groups */}


            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "#FFFFFF", marginTop: "30px", borderBottom: "1px solid #D8DDE4"}}>
                <Typography style={{fontSize: 20, fontWeight: 500, color: "#000000"}}>User Groups</Typography>
            </div>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", backgroundColor: "#FFFFFF", marginTop: "10px", textOverflow: "ellipsis", overflow: "hidden"}}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                    <Typography style={{fontSize: 14, fontWeight: 500, color: "#000000"}}>Primary User Group:&nbsp;&nbsp;</Typography>
                    <Typography style={{fontSize: 14, fontWeight: 400, color: Grey5}}>{projectPlanBuffer.get("PrimaryUserGroupName")} (Primary Employee: {projectPlanBuffer.get("PrimaryUserGroupPrimaryUserName")})</Typography>
                    {projectPlanBuffer.get("PrimaryPositionPrimaryEmployeeUSID") === sessionContext.getEmployeeUSID() || projectPlanBuffer.get("PrimaryUserGroupPrimaryEmployeeUSID") === sessionContext.getEmployeeUSID() || hasPrivilege("PROJECT_MILESTONE_ADMINISTRATION") ? (
                        <Tooltip title={"Change Primary User Group"}>
                            <IconButton className={css_buttons.blueIconButton} style={{marginLeft: "5px", marginTop: "-6px"}} onClick={() => {
                                let attribute = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")?.getAttribute("PrimaryUserGroupUSID")
                                let picklist = attribute?.getPicklist()!;
                                if (adminUserGroupMembershipBuffer.length > 0) {
                                    picklist.setAllowNoSelection(false);
                                } else {
                                    picklist.setAllowNoSelection(true);
                                }
                                setShowEditPrimaryUserGroup(true);
                            }}>
                                <Edit sx={{color: Blue3, width: "20px", height: "20px"}}/>
                            </IconButton>
                        </Tooltip>
                    ): (
                        <>
                            <Tooltip title={"Only the Primary Employee of either the Primary Position or the Primary User Group can change the Primary User Group"}>
                                <IconButton className={css_buttons.blueIconButton} style={{marginLeft: "5px", marginTop: "-6px"}}>
                                    <Edit sx={{color: Grey5, width: "20px", height: "20px"}}/>
                                </IconButton>
                            </Tooltip>
                        </>
                    )}
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", backgroundColor: "#FFFFFF", marginTop: "0px", textOverflow: "ellipsis", overflow: "hidden"}}>
                    <div>
                        {projectPlanBuffer.get("PrimaryUserGroupUSID") !== null && (projectPlanBuffer.get("PrimaryPositionPrimaryEmployeeUSID") === sessionContext.getEmployeeUSID() || projectPlanBuffer.get("PrimaryUserGroupPrimaryEmployeeUSID") === sessionContext.getEmployeeUSID() || hasPrivilege("PROJECT_MILESTONE_ADMINISTRATION")) ? (
                            <Button
                                    className={css_buttons.blueIconButton} style={{marginLeft: "5px", marginTop: "-5px"}}
                                    onClick={() => {
                                        let attribute = adminUserGroupMembershipEnterpriseComponent.getAttribute("UserGroupUSID")
                                        attribute?.getPicklist()!.setAllowNoSelection(false);
                                        addSecondaryUserGroup()
                                    }}
                                    startIcon={<ControlPoint sx={{color: Blue3, width: "20px", height: "20px"}}/>}>
                                <Typography style={{fontSize: 14, fontWeight: 500, color: "#000000"}}>Add Secondary User Group</Typography>
                            </Button>
                        ): (
                            <Button disabled={true}
                                    className={css_buttons.blueIconButton} style={{marginLeft: "5px", marginTop: "-5px"}}
                                    startIcon={<ControlPoint sx={{color: Grey5, width: "20px", height: "20px"}}/>}>
                                <Typography style={{fontSize: 14, fontWeight: 500, color: Grey5}}>Add Secondary User Group</Typography>
                            </Button>
                        )}
                    </div>
                </div>
            </div>
            {projectPlanBuffer.get("PrimaryUserGroupUSID") !== null ? (
                <div style={{display: "flex", flexDirection: "column", backgroundColor: Grey3, border: "1px solid #7B8291", borderBottom: "0px", borderTopLeftRadius: "10px", borderTopRightRadius: "10px", borderBottomLeftRadius: adminUserGroupMembershipBuffer.length === 0 ? "5px": "0px", borderBottomRightRadius: adminUserGroupMembershipBuffer.length === 0 ? "5px": "0px", marginTop: "20px"}}>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "transparent", borderBottom: "1px solid #7B8291"}}>
                        <div style={{width: "410px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px"}}>Primary User Group</Typography></div>
                        <div style={{width: "5px"}}><Typography style={{fontSize: 26, fontWeight: 500, color: Grey6, marginTop: "0px"}}>|</Typography></div>
                        <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px"}}>User Group Membership</Typography></div>
                    </div>
                    {adminUserGroupBuffer && adminUserGroupBuffer.length > 0 ? (
                        <div key={adminUserGroupBuffer[0].get("USID")} style={{display: "flex", flexDirection: "row", justifyContent: "space-between", backgroundColor: "#FFFFFF", borderBottom: "1px solid #EDEFF3"}}>
                            <div style={{display: "flex", flexDirection: "row"}}>
                                <div style={{marginTop: "10px", marginBottom: "10px", width: "410px"}}>
                                    <Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px", textOverflow: "ellipsis", overflow: "hidden"}}>{adminUserGroupBuffer[0].get("Name")}</Typography>
                                </div>
                                <div style={{width: "300px", display: "flex", flexDirection: "column", marginTop: "5px"}}>
                                    {adminUserGroupBuffer[0].get("ListOfEmployee").Employee.length === 0 ? (
                                         <div style={{display: "flex", flexDirection: "row"}}>
                                            <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Grey5, margin: "15px 0 8px 10px"}}>No members</Typography></div>
                                        </div>
                                    ): null}
                                    {adminUserGroupBuffer[0].get("ListOfEmployee").Employee.map((employee: any) => (
                                        <div key={employee.USID} style={{display: "flex", flexDirection: "row"}}>
                                            <div style={{fontSize: 14, fontWeight: 500, color: Black, margin: "3px 0 0 10px"}}>
                                                <Avatar sx={{bgcolor: Blue3, width: 25, height: 25, fontSize: "12px"}}>{stringAvatar(employee.UserName)}</Avatar>
                                            </div>
                                            <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "5px 0 8px 10px"}}>{employee.UserName}</Typography></div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {adminUserGroupMembershipBuffer.length === 0 ? <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "transparent", height: "5px"}}/> : null}
                </div>
            ) : null}
            {adminUserGroupMembershipBuffer.length > 0 ? (
                <div style={{display: "flex", flexDirection: "column", backgroundColor: Grey3, border: "1px solid #7B8291", borderTopLeftRadius: "0px", borderTopRightRadius: "0px", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px", marginTop: "0px"}}>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "transparent", borderBottom: "1px solid #7B8291"}}>
                        <div style={{width: "410px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "10px"}}>Secondary User Groups</Typography></div>
                        <div style={{width: "5px"}}><Typography style={{fontSize: 26, fontWeight: 500, color: "#7B8291", marginTop: "0px"}}>|</Typography></div>
                        <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "10px"}}>User Group Membership</Typography></div>
                    </div>
                    {adminUserGroupMembershipBuffer.map(member => (
                        <div key={member.get("UserGroupUSID")} style={{display: "flex", flexDirection: "row", justifyContent: "space-between", backgroundColor: "#FFFFFF", borderBottom: "1px solid #EDEFF3"}}>
                             <div style={{display: "flex", flexDirection: "row"}}>
                                <div style={{marginTop: "10px", marginBottom: "10px", width: "410px"}}>
                                    <Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "10px", textOverflow: "ellipsis", overflow: "hidden"}}>{member.get("UserGroupName")}</Typography>
                                </div>
                                <div style={{width: "300px", display: "flex", flexDirection: "column", marginTop: "5px"}}>
                                    {member.get("Employees").length === 0 ? (
                                         <div style={{display: "flex", flexDirection: "row"}}>
                                            <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Grey5, margin: "15px 0 8px 10px"}}>No members</Typography></div>
                                        </div>
                                    ): null}
                                    {member.get("Employees").map((employee: any) => (
                                        <div key={employee.USID} style={{display: "flex", flexDirection: "row"}}>
                                            <div style={{fontSize: 14, fontWeight: 500, color: Black, margin: "3px 0 0 10px"}}>
                                                <Avatar sx={{bgcolor: Blue3, width: 25, height: 25, fontSize: "12px"}}>{stringAvatar(employee.UserName)}</Avatar>
                                            </div>
                                            <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: Black, margin: "5px 0 8px 10px"}}>{employee.UserName}</Typography></div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div style={{width: "150px", display: "flex", flexDirection: "column"}}>
                                {projectPlanBuffer.get("PrimaryUserGroupPrimaryEmployeeUSID") === sessionContext.getEmployeeUSID() || hasPrivilege("PROJECT_MILESTONE_ADMINISTRATION") ? (
                                    <div style={{margin: "auto"}}>
                                        {member.get("USID") !== adminUserGroupMembershipDeleteUSID ? (
                                            <Button style={{marginTop: "10px", marginBottom: "10px", width: "100px"}} className={css_buttons.blueStandardButton} onClick={(e: any) => {
                                                disassociateSecondaryUserGroup(member.get("USID"))
                                            }}>Disassociate
                                            </Button>
                                        ) : (
                                            <>
                                                {member.get("USID") === adminUserGroupMembershipDeleteUSID ? (
                                                    <img style={{position: "relative"}} width="55" height="55" src={spinner} alt="spinner" />
                                                ) : null}
                                            </>
                                        )}
                                    </div>
                                ) : (
                                    <div style={{margin: "auto"}}>
                                        <Tooltip title={"Only the Primary Employee (" + projectPlanBuffer.get("PrimaryUserGroupPrimaryUserName") + ") can disassociate a user group"}>
                                            <Button className={css_buttons.blueStandardButton} style={{backgroundColor: "#A8A9AF", width: "100px"}}>Disassociate
                                            </Button>
                                        </Tooltip>
                                    </div>
                                )}
                            </div>
                       </div>
                    ))}
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "transparent", height: "5px"}}/>
                </div>
            ) : null}

            {/*-- Work Groups */}

            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "#FFFFFF", marginTop: "30px", borderBottom: "1px solid #D8DDE4"}}>
                <Typography style={{fontSize: 20, fontWeight: 500, color: "#000000"}}>Work Groups</Typography>
            </div>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", backgroundColor: "#FFFFFF", marginTop: "10px", textOverflow: "ellipsis", overflow: "hidden"}}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                    <Typography style={{fontSize: 14, fontWeight: 500, color: "#000000"}}>Primary Work Group:&nbsp;&nbsp;</Typography>
                    <Typography style={{fontSize: 14, fontWeight: 400, color: Grey5}}>{projectPlanBuffer.get("PrimaryWorkGroupName")} (Primary Employee: {projectPlanBuffer.get("PrimaryWorkGroupPrimaryUserName")})</Typography>
                    {projectPlanBuffer.get("PrimaryPositionPrimaryEmployeeUSID") === sessionContext.getEmployeeUSID() || projectPlanBuffer.get("PrimaryWorkGroupPrimaryEmployeeUSID") === sessionContext.getEmployeeUSID() || hasPrivilege("PROJECT_MILESTONE_ADMINISTRATION") ? (
                        <Tooltip title={"Change Primary Work Group"}>
                            <IconButton className={css_buttons.blueIconButton} style={{marginLeft: "5px", marginTop: "-6px"}} onClick={() => {
                                let attribute = projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")?.getAttribute("PrimaryWorkGroupUSID")
                                let picklist = attribute?.getPicklist()!;
                                if (adminWorkGroupMembershipBuffer.length > 0) {
                                    picklist.setAllowNoSelection(false);
                                } else {
                                    picklist.setAllowNoSelection(true);
                                }
                                setShowEditPrimaryWorkGroup(true)
                            }}>
                                <Edit sx={{color: Blue3, width: "20px", height: "20px"}}/>
                            </IconButton>
                        </Tooltip>
                    ): (
                        <>
                            <Tooltip title={"Only the Primary Employee of either the Primary Position or the Primary Work Group can change the Primary Work Group"}>
                                <IconButton className={css_buttons.blueIconButton} style={{marginLeft: "5px", marginTop: "-6px"}}>
                                    <Edit sx={{color: Grey5, width: "20px", height: "20px"}}/>
                                </IconButton>
                            </Tooltip>
                        </>
                    )}
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", backgroundColor: "#FFFFFF", marginTop: "0px", textOverflow: "ellipsis", overflow: "hidden"}}>
                    <div>
                        {projectPlanBuffer.get("PrimaryWorkGroupUSID") !== null && (projectPlanBuffer.get("PrimaryPositionPrimaryEmployeeUSID") === sessionContext.getEmployeeUSID() || projectPlanBuffer.get("PrimaryWorkGroupPrimaryEmployeeUSID") === sessionContext.getEmployeeUSID() || hasPrivilege("PROJECT_MILESTONE_ADMINISTRATION")) ? (
                            <Button
                                    className={css_buttons.blueIconButton} style={{marginLeft: "5px", marginTop: "-5px"}}
                                    onClick={() => addSecondaryWorkGroup()}
                                    startIcon={<ControlPoint sx={{color: Blue3, width: "20px", height: "20px"}}/>}>
                                <Typography style={{fontSize: 14, fontWeight: 500, color: "#000000"}}>Add Secondary Work Group</Typography>
                            </Button>
                        ): (
                            <Button disabled={true}
                                    className={css_buttons.blueIconButton} style={{marginLeft: "5px", marginTop: "-5px"}}
                                    startIcon={<ControlPoint sx={{color: Grey5, width: "20px", height: "20px"}}/>}>
                                <Typography style={{fontSize: 14, fontWeight: 500, color: Grey5}}>Add Secondary Work Group</Typography>
                            </Button>
                        )
                        }
                    </div>
                </div>
            </div>
            {adminWorkGroupMembershipBuffer.length > 0 ? (
                <div style={{display: "flex", flexDirection: "column", backgroundColor: "#D8DDE4", border: "1px solid #7B8291", borderTopLeftRadius: "10px", borderTopRightRadius: "10px", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px", marginTop: "20px"}}>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "transparent", borderBottom: "1px solid #7B8291"}}>
                        <div style={{width: "410px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "10px"}}>Secondary Work Groups</Typography></div>
                        <div style={{width: "5px"}}><Typography style={{fontSize: 26, fontWeight: 500, color: "#7B8291", marginTop: "0px"}}>|</Typography></div>
                        <div style={{width: "800px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "10px"}}>Work Group Membership</Typography></div>
                    </div>
                    {adminWorkGroupMembershipBuffer.map(workGroup => (
                        <div key={workGroup.get("WorkGroupUSID")} style={{display: "flex", flexDirection: "row", justifyContent: "space-between", backgroundColor: "#FFFFFF", borderBottom: "1px solid #EDEFF3", width: "100%"}}>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                                <div key={workGroup.get("WorkGroupUSID")} style={{width: "410px"}}>
                                    <Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "10px", textOverflow: "ellipsis", overflow: "hidden"}}>{workGroup.get("WorkGroupName")}</Typography>
                                </div>
                                <div key={2} style={{width: "800px", display: "flex", flexDirection: "column", marginTop: "5px"}}>
                                    <div key={1} style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "#EDEFF3", borderBottom: "1px solid #7B8291"}}>
                                        <div style={{width: "310px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "10px"}}>Position Membership</Typography></div>
                                    </div>
                                    {workGroup.get("AdminWorkGroup").ListOfAdminPosition.AdminPosition.map((position: any, index: number) => (
                                        <div key={position.USID} style={{display: "flex", flexDirection: "row", borderBottom: (index !== workGroup.get("AdminWorkGroup").ListOfAdminPosition.AdminPosition.length - 1) ? "1px solid #EDEFF3" : "0px solid #EDEFF3"}}>
                                            <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "10px 0 8px 10px"}}>{position.Name}</Typography></div>
                                            <div style={{width: "300px", display: "flex", flexDirection: "column", marginTop: "5px"}}>
                                                {position.ListOfAdminWorkGroupPositionEmployee.AdminWorkGroupPositionEmployee.map((employee: any) => (
                                                    <div key={employee.USID} style={{display: "flex", flexDirection: "row"}}>
                                                        <div style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "3px 0 0 10px"}}>
                                                            <Avatar sx={{bgcolor: Blue3, width: 25, height: 25, fontSize: "12px"}}>{stringAvatar(employee.UserName)}</Avatar>
                                                        </div>
                                                        <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "5px 0 8px 10px"}}>{employee.UserName}</Typography></div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                    <div key={2} style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "#EDEFF3", borderBottom: "1px solid #7B8291", borderTop: "1px solid #EDEFF3", marginTop: "20px"}}>
                                        <div style={{width: "310px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "10px"}}>User Group Membership</Typography></div>
                                    </div>
                                    {workGroup.get("AdminWorkGroup").ListOfAdminUserGroup.AdminUserGroup.map((userGroup: any, index: number) => (
                                        <div key={userGroup.USID} style={{display: "flex", flexDirection: "row", borderBottom: (index !== workGroup.get("AdminWorkGroup").ListOfAdminUserGroup.AdminUserGroup.length - 1) ? "1px solid #EDEFF3" : "0px solid #EDEFF3"}}>
                                            <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "10px 0 8px 10px"}}>{userGroup.Name}</Typography></div>
                                            <div style={{width: "300px", display: "flex", flexDirection: "column", marginTop: "5px"}}>
                                                {userGroup.ListOfAdminUserGroupEmployee.AdminUserGroupEmployee.map((employee: any) => (
                                                    <div key={employee.USID} style={{display: "flex", flexDirection: "row"}}>
                                                        <div style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "3px 0 0 10px"}}>
                                                            <Avatar sx={{bgcolor: Blue3, width: 25, height: 25, fontSize: "12px"}}>{stringAvatar(employee.UserName)}</Avatar>
                                                        </div>
                                                        <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "5px 0 8px 10px"}}>{employee.UserName}</Typography></div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                    <div key={3} style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "#EDEFF3", borderBottom: "1px solid #7B8291", borderTop: "1px solid #EDEFF3", marginTop: "20px"}}>
                                        <div style={{width: "310px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "10px"}}>Organization Membership</Typography></div>
                                    </div>
                                    {workGroup.get("AdminWorkGroup").ListOfAdminOrganization.AdminOrganization.map((organization: any) => (
                                        <div key={organization.USID} style={{display: "flex", flexDirection: "row", marginTop: "5px"}}>
                                            <div key={1} style={{width: "300px"}}>
                                                <Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "5px 0 8px 10px"}}>{organization.Name}</Typography>
                                            </div>
                                            <div key={2} style={{width: "500px", display: "flex", flexDirection: "column", justifyContent: "flex-start", backgroundColor: "#EDEFF3"}}>
                                                <div style={{borderBottom: "1px solid #7B8291" }}>
                                                    <Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "10px"}}>Position Membership</Typography>
                                                </div>
                                                {organization.ListOfAdminWorkGroupOrganizationPosition.AdminWorkGroupOrganizationPosition.map((position: any, index: number) => (
                                                    <div key={position.USID} style={{display: "flex", flexDirection: "row", backgroundColor: "#FFFFFF", borderBottom: (index !== organization.ListOfAdminWorkGroupOrganizationPosition.AdminWorkGroupOrganizationPosition.length - 1) ? "1px solid #EDEFF3" : "0px solid #EDEFF3"}}>
                                                        <div style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "10px 0 8px 10px"}}>{position.Name}</Typography></div>
                                                        <div key={position.USID} style={{width: "300px", display: "flex", flexDirection: "column", backgroundColor: "#FFFFFF", marginTop: "5px"}}>
                                                            {position.ListOfAdminWorkGroupOrganizationPositionEmployee.AdminWorkGroupOrganizationPositionEmployee.map((employee: any) => (
                                                                <div key={employee.USID} style={{display: "flex", flexDirection: "row", marginTop: "2px"}}>
                                                                    <div style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "2px 0 0 10px"}}>
                                                                        <Avatar sx={{bgcolor: Blue3, width: 25, height: 25, fontSize: "12px"}}>{stringAvatar(employee.UserName)}</Avatar>
                                                                    </div>
                                                                    <div>
                                                                        <Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "3px 0 8px 10px"}}>{employee.UserName}</Typography>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                    <div key={4} style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "#EDEFF3", borderBottom: "1px solid #7B8291", borderTop: "1px solid #EDEFF3", marginTop: "20px"}}>
                                        <div style={{width: "310px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "10px"}}>Employee Membership</Typography></div>
                                    </div>
                                    {workGroup.get("AdminWorkGroup").ListOfWorkGroupEmployee.WorkGroupEmployee.map((employee: any) => (
                                        <div key={employee.USID} style={{display: "flex", flexDirection: "row", marginTop: "5px"}}>
                                            <div key={1} style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "3px 0 0 10px"}}>
                                                <Avatar sx={{bgcolor: Blue3, width: 25, height: 25, fontSize: "12px"}}>{stringAvatar(employee.UserName)}</Avatar>
                                            </div>
                                            <div key={2} style={{width: "300px"}}><Typography style={{fontSize: 14, fontWeight: 500, color: "#000000", margin: "5px 0 8px 10px"}}>{employee.UserName}</Typography></div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div style={{width: "150px", display: "flex", flexDirection: "column", alignContent: "flex-end"}}>
                                {projectPlanBuffer.get("PrimaryWorkGroupPrimaryEmployeeUSID") === sessionContext.getEmployeeUSID() || hasPrivilege("PROJECT_MILESTONE_ADMINISTRATION") ? (
                                    <div style={{margin: "auto"}}>
                                        <Button style={{width: "100px"}} className={css_buttons.blueStandardButton} onClick={(e: any) => {
                                            disassociateSecondaryWorkGroup(workGroup.get("WorkGroupUSID"))
                                        }}>Disassociate
                                        </Button>
                                    </div>
                                ) : (
                                    <div style={{margin: "auto"}}>
                                        <Tooltip title={"Only the Primary Employee (" + projectPlanBuffer.get("PrimaryWorkGroupPrimaryUserName") + ") can disassociate a work group"}>
                                            <Button className={css_buttons.blueStandardButton} style={{backgroundColor: "#A8A9AF", width: "100px"}}>Disassociate
                                            </Button>
                                        </Tooltip>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", backgroundColor: "transparent", height: "5px"}}/>
                </div>
            ): null}
        </div>
    );

    let permissionView = (
        <>
            <div key={1} style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                <Typography style={{fontSize: 14, fontWeight: 500, color: "#A8A9AF", margin: "10px 0 0 0"}}>Changes to these settings will only effect {projectPlanBuffer.get("ProjectPlanID")} - {projectPlanBuffer.get("Name")}</Typography>
            </div>
            <div key={2} style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
                <PermissionConfiguration name={"EDIT_PLAN"} projectPlanBuffer={projectPlanBuffer}/>
                <PermissionConfiguration name={"DELETE_PLAN"} projectPlanBuffer={projectPlanBuffer}/>
                <PermissionConfiguration name={"ADD_PHASE"} projectPlanBuffer={projectPlanBuffer}/>
                <PermissionConfiguration name={"EDIT_PHASE"} projectPlanBuffer={projectPlanBuffer}/>
                <PermissionConfiguration name={"DELETE_PHASE"} projectPlanBuffer={projectPlanBuffer}/>
                <PermissionConfiguration name={"ADD_MILESTONE"} projectPlanBuffer={projectPlanBuffer}/>
                <PermissionConfiguration name={"EDIT_MILESTONE"} projectPlanBuffer={projectPlanBuffer}/>
                <PermissionConfiguration name={"DELETE_MILESTONE"} projectPlanBuffer={projectPlanBuffer}/>
                <PermissionConfiguration name={"ADD_MILESTONE_REFERENCE"} projectPlanBuffer={projectPlanBuffer}/>
                <PermissionConfiguration name={"EDIT_MILESTONE_REFERENCE"} projectPlanBuffer={projectPlanBuffer}/>
                <PermissionConfiguration name={"DELETE_MILESTONE_REFERENCE"} projectPlanBuffer={projectPlanBuffer}/>
                <PermissionConfiguration name={"ADD_MILESTONE_ASSIGNEE"} projectPlanBuffer={projectPlanBuffer}/>
                <PermissionConfiguration name={"EDIT_MILESTONE_ASSIGNEE"} projectPlanBuffer={projectPlanBuffer}/>
                <PermissionConfiguration name={"DELETE_MILESTONE_ASSIGNEE"} projectPlanBuffer={projectPlanBuffer}/>
                <PermissionConfiguration name={"ADD_PHASE_ATTACHMENT"} projectPlanBuffer={projectPlanBuffer}/>
                <PermissionConfiguration name={"DOWNLOAD_PHASE_ATTACHMENT"} projectPlanBuffer={projectPlanBuffer}/>
                <PermissionConfiguration name={"DELETE_PHASE_ATTACHMENT"} projectPlanBuffer={projectPlanBuffer}/>
            </div>
        </>
    );

    let historyView = (
        <div style={{paddingLeft: "0px", paddingTop: "30px", width: "100%"}}>
            <ProjectPlanAuditLogTableApplet enterpriseComponent={projectPlanEnterpriseObject?.getEnterpriseComponent("ProjectPlanAuditLog")} PageSize={{
                "default": 20,
            }}/>
        </div>
    )

    function renderFilterByMilestoneAssignees() {
        let firstButtonHandlerContent = (
            <CCButton
                className={css_buttons.redStandardButton}
                onClick={() => {
                    setShowMilestonesByAssigneeDialog(false);
                    setCurrentAssigneeFilterUSID(undefined);
                    setShowMilestonesByAssignee(false);
                    setShowMyMilestones(false);
                    setShowFilterMenu(null);
                    setActiveFilter(null)
                    setShowMilestonesByAssigneeUSID(null);
                }}>
                Cancel
            </CCButton>
        );

        let secondButtonHandlerContent = (
            <CCButton
                className={css_buttons.blueStandardButton}
                disabled={currentAssigneeFilterUSID === undefined}
                onClick={() => setShowMilestonesByAssigneeDialog(false)}>
                Done
            </CCButton>
        );

        let buttonHandler = (
            <DialogActions style={{marginBottom: "10px", width: "96%"}}>
                {firstButtonHandlerContent}
                {secondButtonHandlerContent}
            </DialogActions>
        );

        let content: any[] = [];

        let phases: any[] = projectPlanBuffer.get("ProjectPlanPhases")
        for (let i= 0; i < phases.length; i++) {
            let phase = phases[i];
            let milestones = phase.ListOfProjectPlanPhaseMilestone.ProjectPlanPhaseMilestone;

            for (let j = 0; j < milestones.length; j++) {
                let milestone = milestones[j];

                let employees = milestone.ListOfProjectPlanPhaseMilestoneEmployee.ProjectPlanPhaseMilestoneEmployee;
                for (let k = 0; k < employees.length; k++) {
                    content.push(employees[k])
                }
            }
        }

        return (
            <>
                <Dialog open={true} scroll="body">
                    <DialogTitle>Filter</DialogTitle>
                    <DialogContent>
                        <div style={{display: "flex", justifyContent: "left", marginTop: "10px", marginBottom: "40px"}}>
                            <TextField select={true}
                                       fullWidth={true}
                                       size="small"
                                       label={"Assignee"}
                                       value={currentAssigneeFilterUSID}
                                       onChange={(e) => setCurrentAssigneeFilterUSID(e.target.value)}
                                       variant="outlined"
                                       slotProps={{
                                           input: {

                                           },
                                           inputLabel: {
                                               shrink: true
                                           }
                                       }}>
                                {content.map((employee: any, i: number) => (
                                    <MenuItem value={employee["EmployeeUSID"]} onClick={(e) => {
                                        setShowMilestonesByAssignee(true);
                                        setShowFilterMenu(null);
                                        setActiveFilter({"Title": "Milestone by Assignee", "Subtitle": e.currentTarget.textContent!});
                                        setShowMilestonesByAssigneeUSID(employee["EmployeeUSID"])
                                }}>{employee["EmployeeName"]}</MenuItem>
                                ))}

                            </TextField>
                        </div>
                    </DialogContent>
                    {buttonHandler}
                </Dialog>
            </>
        );
    }

    return (
        <>
            {showAddPhase ? <ProjectPlanPhaseFormApplet enterpriseComponent={projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanPhase")} defaultAction={"New"}/> : null}
            {showAddPhaseMilestone ? <ProjectPlanPhaseMilestoneFormApplet enterpriseComponent={projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlanPhaseMilestone")} defaultAction={"New"}/> : null}
            {showPanelForMilestone ? <ProjectPlanPhaseMilestoneDetail key="asfdadfsadf" projectPlanPhaseMilestoneUSID={showPanelForMilestone!["USID"]} projectPlanPhaseUSID={showPanelForMilestone!["ProjectPlanPhaseUSID"]} projectPlanBuffer={projectPlanBuffer} /> : null}
            {showPanelForPhase ? <ProjectPlanPhaseDetail projectPlanPhaseUSID={showPanelForPhase!["USID"]} projectPlanBuffer={projectPlanBuffer} /> : null}
            {showDeletePhaseMilestone ? <ProjectPlanPhaseMilestoneDelete projectPlanPhaseMilestone={showDeletePhaseMilestone}/> : null}
            {showDeletePhase ? <ProjectPlanPhaseDelete projectPlanPhase={showDeletePhase}/> : null}
            {showMilestoneRelocate ? <ProjectPlanMilestoneRelocate projectPlanBuffer={projectPlanBuffer} projectPlanPhaseMilestone={showMilestoneRelocate}/> : null}
            {showDeletePlan ? <ProjectPlanDelete projectPlanUSID={projectPlanBuffer.get("USID")} projectPlanName={projectPlanBuffer.get("Name")}/> : null}
            {showEditPlan ? <ProjectPlanFormApplet enterpriseComponent={projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")} defaultAction={"Edit"}/> : null}
            {showEditPrimaryPosition ? (<PrimaryPositionFormApplet enterpriseComponent={projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!} defaultAction="Edit"/>) : null}
            {showEditPrimaryUserGroup ? (<PrimaryUserGroupFormApplet enterpriseComponent={projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!} defaultAction="Edit"/>) : null}
            {showEditPrimaryWorkGroup ? (<PrimaryWorkGroupFormApplet enterpriseComponent={projectPlanEnterpriseObject.getEnterpriseComponent("ProjectPlan")!} defaultAction="Edit"/>) : null}
            {showAddSecondaryPosition ? (<SecondaryPositionFormApplet enterpriseComponent={adminPositionMembershipEnterpriseComponent} defaultAction="New"/>) : null}
            {showAddSecondaryUserGroup ? (<SecondaryUserGroupFormApplet enterpriseComponent={adminUserGroupMembershipEnterpriseComponent} defaultAction="New"/>) : null}
            {showCopyMilestone ? (<CopyMilestone milestoneUSID={showCopyMilestone["USID"]} milestoneName={showCopyMilestone["Name"]}/>) : null}
            {showCopyPhase ? (<CopyPhase phaseUSID={showCopyPhase["USID"]} phaseName={showCopyPhase["Name"]}/>) : null}
            {showCopyPlan ? (<CopyPlan planUSID={projectPlanBuffer.get("USID")} planName={projectPlanBuffer.get("Name")}/>) : null}
            {showMilestonesByAssigneeDialog ? renderFilterByMilestoneAssignees() : null}

            <div style={{display: "flex", flexDirection: "column", flexGrow: 1, padding: "15px 20px 20px 30px"}}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#FFFFFF"}}>
                    <div style={{display: "flex", flexDirection: "row", paddingTop: "11px"}}>
                        <IconButton
                            className={css_buttons.whiteStandardButton} style={{marginLeft: "-23px", marginTop: "-5px", cursor: "pointer"}} size="small"
                            onClick={() => {
                                sessionContext.setURL("");
                                navigate("/project-plan");
                            }}>
                            <KeyboardBackspace sx={{color: "#021EBB", width: "30px", height: "30px"}}/>
                        </IconButton>
                        <Typography style={{fontSize: 20, fontWeight: 500, color: "#000000"}}>{projectPlanBuffer.get("ProjectPlanID")} - {projectPlanBuffer.get("Name")}</Typography>
                        <div style={{marginLeft: "10px", marginTop: "2px"}}>
                            <Chip label={status} size="small" style={{fontSize: 12, backgroundColor: backgroundColor, color: "#FFFFFF", marginTop: "3px"}}/>
                        </div>
                        <div style={{marginTop: "0px"}}>
                            <Tooltip title={"Edit Project Plan"}>
                                <IconButton className={css_buttons.blueIconButton} style={{marginLeft: "5px"}} disabled={projectPlanFetchBackgroundOperation || !hasPrivilege("EDIT_PLAN", inboundProjectPlanUSID!)} onClick={() => {
                                    setShowEditPlan(true);
                                }}>
                                    <Edit sx={{color: Blue3, width: "20px", height: "20px", marginTop: "0px"}}/>
                                </IconButton>
                            </Tooltip>
                        </div>
                        {!hasPrivilege("EDIT_PLAN", inboundProjectPlanUSID!) ? (
                            <div style={{marginTop: "5px"}}>
                                <Tooltip title={"This feature is disabled because you do not have the 'EDIT_PLAN' privilege in any of your assigned roles."}>
                                    <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                </Tooltip>
                            </div>
                        ) : null}

                    </div>
                    <div style={{display: "flex", flexDirection: "row", paddingTop: "8px"}}>
                        <CloudDone sx={{color: Blue3, width: "20px", height: "20px", marginTop: "5px", marginRight: "10px"}}/>
                        <Typography style={{fontSize: "13px", fontWeight: 400, color: "#000000", marginTop: "7px"}}>{formatLastEdit()}</Typography>
                        <div style={{display: "flex", flexDirection: "row", marginLeft: "10px"}}>
                            <Button
                                className={css_buttons.blueStandardButton} style={{cursor: "pointer", height: "35px", padding: "0 15px 0 15px"}} disabled={projectPlanFetchBackgroundOperation} size="small"
                                onClick={() => {
                                    setShowCopyPlan(true)
                                }}
                                startIcon={<ContentCopy sx={{color: "#FFFFFF", width: "25px", height: "25px"}}/>}>
                                Copy Plan
                            </Button>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", marginLeft: "10px"}}>
                            <Button
                                className={css_buttons.blueStandardButton} style={{cursor: "pointer", height: "35px", padding: "0 15px 0 15px"}} size="small" disabled={projectPlanFetchBackgroundOperation || !hasPrivilege("DELETE_PLAN", inboundProjectPlanUSID!)}
                                onClick={() => {
                                    setShowDeletePlan(true)
                                }}
                                startIcon={<Delete sx={{color: "#FFFFFF", width: "25px", height: "25px"}}/>}>
                                Delete Plan
                            </Button>
                            {!hasPrivilege("DELETE_PLAN", inboundProjectPlanUSID!) ? (
                                <div style={{marginLeft: "2px", marginTop: "5px"}}>
                                    <Tooltip title={"This feature is disabled because you do not have the 'Delete Plan' privilege."}>
                                        <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                    </Tooltip>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", width: "100%", marginTop: "2px", height: "auto", backgroundColor: "#FFFFFF", borderBottom: "1px solid #D8DDE4"}}>
                    <div style={{marginRight: "30px", borderBottomStyle: "solid", borderBottomWidth: pane === "PLANNING" ? "2px" : "0px", borderBottomColor: "#021EBB"}}>
                        <Link underline="none" variant="inherit" color="inherit" href="#" onClick={e => {
                            e.preventDefault();
                            setPane("PLANNING")
                        }}><Typography style={{fontSize: "13px", fontWeight: 600, color: pane === "PLANNING" ? "#021EBB" : "#7B8291", marginTop: "10px"}}>PLANNING</Typography></Link>
                    </div>
                    {projectPlanBuffer.get("PrimaryPositionPrimaryEmployeeUSID") === sessionContext.getEmployeeUSID() || hasPrivilege("PROJECT_MILESTONE_ADMINISTRATION") ? (
                        <div style={{marginRight: "30px", borderBottomStyle: "solid", borderBottomWidth: pane === "VISIBILITY" ? "2px" : "0px", borderBottomColor: "#021EBB"}}>
                            <Link underline="none" variant="inherit" color="inherit" href="#" onClick={e => {
                                e.preventDefault();
                                setPane("VISIBILITY")
                            }}><Typography style={{fontSize: "13px", fontWeight: 600, color: pane === "VISIBILITY" ? "#021EBB" : "#7B8291", marginTop: "10px"}}>VISIBILITY</Typography></Link>
                        </div>
                    ) : null}
                    {hasPrivilege("PROJECT_MILESTONE_ADMINISTRATION") ? (
                        <div style={{marginRight: "30px", borderBottomStyle: "solid", borderBottomWidth: pane === "PERMISSIONS" ? "2px" : "0px", borderBottomColor: "#021EBB"}}>
                            <Link underline="none" variant="inherit" color="inherit" href="#" onClick={e => {
                                e.preventDefault();
                                setPane("PERMISSIONS")
                            }}><Typography style={{fontSize: "13px", fontWeight: 600, color: pane === "PERMISSIONS" ? "#021EBB" : "#7B8291", marginTop: "10px"}}>PERMISSIONS</Typography></Link>
                        </div>
                    ) : null}
                    <div style={{marginRight: "30px", borderBottomStyle: "solid", borderBottomWidth: pane === "HISTORY" ? "2px" : "0px", borderBottomColor: "#021EBB"}}>
                        <Link underline="none" variant="inherit" color="inherit" href="#" onClick={e => {
                            e.preventDefault();
                            setPane("HISTORY")
                        }}><Typography style={{fontSize: "13px", fontWeight: 600, color: pane === "HISTORY" ? "#021EBB" : "#7B8291", marginTop: "10px"}}>HISTORY</Typography></Link>
                    </div>
                </div>
                {pane === "PLANNING" ? planningView : null}
                {pane === "VISIBILITY" ? visibilityView : null}
                {pane === "PERMISSIONS" ? permissionView : null}
                {pane === "HISTORY" ? historyView : null}
            </div>
        </>
    );
}